import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/Cancel';
import SendIcon from '@material-ui/icons/Send';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import DateFnsUtils from '@date-io/date-fns';
import React, { useEffect, useState, useRef } from 'react';
import trLocale from 'date-fns/locale/tr';
import CloseIcon from '@material-ui/icons/Close';
import ImageSearchIcon from '@material-ui/icons/ImageSearch';
import SearchIcon from '@material-ui/icons/Search';
import SearchBar from 'material-ui-search-bar';
import LocalGroceryStoreIcon from '@material-ui/icons/LocalGroceryStore';
import { sc, moneyFormat } from 'src/utils/Common';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import CardMembershipIcon from '@material-ui/icons/CardMembership';
import VirtualStockPanel from 'src/components/VirtualStockPanel';
import {
  Card,
  Avatar,
  Input,
  DialogContent,
  Breadcrumbs,
  Link,
  Typography,
  CardContent,
  Container,
  Divider,
  Dialog,
  DialogTitle,
  DialogActions,
  BottomNavigation,
  BottomNavigationAction,
  Grid,
  IconButton,
  TextField,
  ThemeProvider,
  CardHeader,
  Box,
  FormControlLabel,
  Backdrop,
  CircularProgress,
  Button,
  Snackbar,
  Checkbox,
  Chip,
  TablePagination, ListItemAvatar, ListItem, ListItemText, List, Tabs, Tab, AppBar, OutlinedInput, InputAdornment, DialogContentText, FormControl, MenuItem
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { createTheme } from '@material-ui/core/styles';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import { makeStyles, withStyles } from '@material-ui/styles';
import * as XLSX from 'xlsx';
import { useTranslation } from 'react-i18next';
import Page from 'src/components/Page';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import AddBoxIcon from '@material-ui/icons/AddBox';
import DeleteIcon from '@material-ui/icons/Delete';
import moment from 'moment';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import Alert from 'src/components/Alert';
import ExcelExport from 'src/components/ExcelExport';
import UrunSearch from 'src/components/Selects/ProductSearch'
import ProductMaterialSearch from 'src/components/Selects/ProductMaterialSearch';
import ControlCameraIcon from '@material-ui/icons/ControlCamera';
import EditMaterial from 'src/components/SelectMaterial/materialOrderEdit';
import ConsumerSearch from 'src/components/Consumer/ConsumerSearch';
import ServiceShopSearch from 'src/components/ServiceShop/ServiceShopSearch';
import ConsumerAddress from 'src/components/Consumer/ConsumerAddress';
import LocalShippingOutlinedIcon from '@material-ui/icons/LocalShippingOutlined';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import axiosServiceShop from 'src/utils/customAxios';
import ServiceShopBillTo from 'src/components/ServiceShop/ServiceShopBillTo';
import { useLocation } from 'react-router-dom';
import Highlighter from 'react-highlight-words';
import { FaTree } from 'react-icons/fa';
import { AiOutlineCheckSquare } from 'react-icons/ai';
import TrackChangesIcon from '@material-ui/icons/TrackChanges';
import SerialNumberParse from 'src/components/SerialNumberParse';
import PinIcon from 'src/components/PinIcon';
import ErpStatusDialog from 'src/components/ErpStatusDialog'
import VisibilityIcon from '@material-ui/icons/Visibility';
import PricePreviewDialog from "src/components/PricePreviewDialog";
import RomaniaStorageLocationDialog from 'src/components/MaterialOrder/RomaniaStorageLocationDialog';

const ROMANIA_TENANT_ID = 49;

//-------------------TABS------------------------
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}


TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

//-----------------------------------------

const useStyles = makeStyles(theme => ({
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0)'
  },
  root: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  },
  cardscontent: {
    minHeight: 300
  },
  backdrop: {
    zIndex: 1500,
    color: '#fff'
  },
  tableRow: {
    '&$hover:hover': {
      backgroundColor: '#DEF5E5'
    }
  },
  tableCell: {
    '$hover:hover &': {
      color: 'black'
    }
  },
  hover: {},
  searchB: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIconB: {
    marginRight: theme.spacing(0),
    color: theme.palette.icon
  },
  searchInputB: {
    flexGrow: 1
  },
  searchButtonB: {
    backgroundColor: theme.palette.common.white,
    marginLeft: theme.spacing(2)
  },
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  totalPriceCell: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  priceBox: {
    border: `3px solid #708871`,
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    color: theme.palette.primary.main,
    backgroundColor: 'transparent',
    fontWeight: 'bold',
    fontSize: '1.0 rem',
    width: '150px'
  },
  currencyUnit: {
    marginLeft: theme.spacing(0.5),
  },
  vatBox: {
    border: `3px solid #708871`,
    padding: theme.spacing(1),
    width: '250px',
    textAlign: 'left',
    margin: '10px',
    backgroundColor: 'transparent',
    borderRadius: theme.shape.borderRadius,
    fontWeight: 'bold',
    fontSize: '1.0 rem',
    position: 'relative'
  },
  price: {
    fontWeight: 'bold',
    fontSize: '1.0 rem'
  },
  pinIcon: {
    position: 'absolute',
    top: '-15px',
    left: '5px',
  },
}));


const EXTENSIONS = ['xlsx', 'xls', 'csv']


const ForPartner = (props) => {
  const classes = useStyles();
  const { t } = useTranslation('overview');
  const [SelectedMaterialPopup, setSelectedMaterialPopup] = useState(false);
  const [UrunData, setUrunData] = useState({});
  const [search] = useState('');
  const [TopBarValue, setTopBarValue] = React.useState(-1);
  const SessionUser = getUser();
  const [stokOpen, setStokOpen] = React.useState(false);
  const [stokData, setStokData] = React.useState([]);
  const [stockDataLoading, setStockDataLoading] = React.useState(false);
  const [materialAvailabilityCode, setMaterialAvailabilityCode] = React.useState([]);
  const [ErpStatusOpen, setErpStatusOpen] = React.useState(false);
  const [ErpStatusData, setErpStatusData] = React.useState([]);
  const [creditLimitOpen, setCreditLimitOpen] = React.useState(false);
  const [creditLimitData, setCreditLimitData] = React.useState([]);
  const [statusList] = useState([
    { Id: 1, Name: t('lblNew') },
    { Id: 2, Name: t('lblCancel') },
    { Id: 3, Name: t('lblSAPSent') },
    { Id: 5, Name: t('lblPricePreview') }
  ]);
  const [selectedStatus, setSelectedStatus] = useState({ Id: 1, Name: 'New' });
  const [StartDateSearch, setStartDateSearch] = useState(
    moment()
      .startOf('day')
      .add(-7, 'days')
      .add(12, 'hours')
      .format('YYYY-MM-DD')
  );
  const [SearchOrderParam, setSearchOrderParam] = React.useState('');
  const [EndDateSearch, setEndDateSearch] = useState(new Date());
  const [SparepartData, setSparePartData] = useState([]);
  const [QueryPopUp, setQueryPopUp] = useState(false);
  const [ServiceShopData, setServiceShopData] = useState([]);
  const [serviceShopId, setServiceShopId] = useState('');
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [ResponseType, setResponseType] = useState('success');
  const [IsHitachiCountry, setIsHitachiCountry] = useState(false);
  const [openPricePreview, setopenPricePreview] = useState(false);
  const [pricePreviewData, setPricePreviewData] = useState([]);

  const [pricePreviewError, setPricePreviewError] = useState({
    isApiSuccess: true,
    hasBusinessError: false,
    errorMessage: null
  });

  const [isSapButtonDisabled, setIsSapButtonDisabled] = useState(false);
  const [storageLocationDialogOpen, setStorageLocationDialogOpen] = useState(false);
  const [sapStorageLocationCode, setSapStorageLocationCode] = useState('');

  const defaultMaterialOrder = {
    service: SessionUser.ServiceShopName,
    orderNumber: '',
    orderDate: moment().format('YYYY-MM-DD'),
    sapNumber: '',
    jobNumber: '',
    poNumber: '',
    modelCode: '',
    status: statusList[0].Name,
    recipientName: '',
    description: '',
    recipientAddress: '',
    StorageLocationId: '',
    ServiceShopId:
      SessionUser.UserType === 1 || SessionUser.UserType === 2
        ? SessionUser.ServiceShopId
        : 0
  };


  const [MaterialOrderData, setMaterialOrderData] = useState(
    defaultMaterialOrder
  );
  const [MaterialListData, setMaterialListData] = useState([]); //Product-Material
  const [MaterialListData2, setMaterialListData2] = useState([]); //Only Material

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [QuerySearchData, setQuerySearchData] = useState([]);
  const [QuerySearchScreenData, setQuerySearchScreenData] = useState([]);
  const [ResponseDsc, setResponseDsc] = useState('');
  const [ImagePopup, setImagePopup] = useState(false);
  const [ImageUrl, setImageUrl] = useState('');
  const [currentStatus, setCurrentStatus] = useState(0);
  const isRomania = SessionUser.TenantId === ROMANIA_TENANT_ID;
  const isStorageLocationButtonEnabled =
    isRomania && Number(MaterialOrderData.orderNumber) > 0 && currentStatus === 1;
  const [searched, setSearched] = useState('');
  const [openEdit, setOpenEdit] = React.useState(false);
  const [materialId, setMaterialId] = React.useState('');
  const [materialCode, setMaterialCode] = React.useState('');
  const [materialDesc, setMaterialDesc] = React.useState('');
  const [sparePartMessage, setSparePartMessage] = React.useState('');
  const [SelectedProductMaterialPopup, setSelectedProductMaterialPopup] = useState(false);
  const [MissingMaterialsPopUp, missingMaterialsPopUp] = React.useState(false);
  const [MissingMaterials, missingMaterials] = React.useState([]);
  const [initialRows, setinitialRows] = useState('');
  const [inputText, setInputText] = useState("");
  const [openWarning, setopenWarning] = React.useState(false);
  const [Uyari, setUyari] = React.useState('');
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [orderData, setOrderData] = React.useState([]);

  const [muadilOpen, setMuadilOpen] = React.useState(false);
  const [muadilParam, setMuadilParam] = React.useState('');
  const [muadilTitle, setMuadilTitle] = React.useState('');
  const [equivalentData, setEquivalentData] = React.useState([]);

  const [stokDataOwnEngineer, setStokDataOwnEngineer] = React.useState([]);
  const [stockMsg, setStockMsg] = React.useState('');
  const [serviceShopTypeId, setServiceShopTypeId] = React.useState();
  const [IsAllOwnEngineer, setIsAllOwnEngineer] = React.useState(false);
  const [backButtonVisible, setBackButtonVisible] = React.useState(false);
  const [rowData, setRowData] = React.useState([]);
  const [totalSum, setTotalSum] = useState(0);
  const [vat, setVat] = useState(0)
  const [priceWithVAT, setPriceWithVAT] = useState(0)
  const [vatRate, setVatRate] = useState(0);
  const [workOrderIdControl, setWorkOrderIdControl] = useState(false);

  const [bomData, setBomData] = useState([]);

  const location = useLocation();
  const initialSelectedRow = location.state ? location.state : '';
  const [currentRow, setCurrentRow] = useState(initialSelectedRow);

  const [selectedValueFOC, setSelectedValueFOC] = React.useState(0);
  const [storageLocation, setStorageLocation] = useState('0');
  const [StorageLocationData, setStorageLocationData] = useState([]);
  const [isDisabled, setIsDisabled] = useState([]);
  const handleChangeFOC = () => {
    setSelectedValueFOC((prevValue) => (prevValue === 0 ? 1 : 0));
  };


  // Virtual Stock
  const [virtualLoading, setVirtualLoading] = React.useState(false);
  const [virtualTotal, setVirtualTotal] = React.useState(0);
  const [virtualInvoices, setVirtualInvoices] = React.useState([]);
  const [showVirtualDetail, setShowVirtualDetail] = useState(false);
  const [virtualStockEnabled, setVirtualStockEnabled] = useState(false);
  const [virtualStockEnabledLoaded, setVirtualStockEnabledLoaded] = useState(false);


  const toggleVirtualDetail = () => setShowVirtualDetail(prev => !prev);

  useEffect(() => {
    axios
      .get('/IsVirtualStockEnabled')
      .then(r => {
        setVirtualStockEnabled(r.data === true);
        setVirtualStockEnabledLoaded(true);
      })
      .catch(() => {
        setVirtualStockEnabled(false);
        setVirtualStockEnabledLoaded(true);
      });
  }, []);




  useEffect(() => {
    if (props?.MaterialOrderIdPopup > 0) {
      setSearchOrderParam(props?.MaterialOrderIdPopup);
      GetMaterialOrderParamNew(props?.MaterialOrderIdPopup);
    }
  }, [props?.MaterialOrderIdPopup]);


  const handleClose = () => {
    setAnchorEl(null);
  };

  const [QuantityState, setQuantityState] = useState({
    value: 1,
    show: 1,
    backgroundColor: 'white',
  });


  const [ConsumerSearchPopUp, setConsumerSearchPopUp] = useState(false);
  const [ServiceShopSearchPopUp, setServiceShopSearchPopUp] = useState(false);

  //--------------------DEFAULT--------------------
  const defaultConsumerData = {
    consumerId: '',
    consumerFullName: '',
    consumerPhoneNumber: ''
  }

  const defaultConsumerAddressData = {
    AddressType: '',
    Address: '',
    State: '',
    AddressItem: '',
    Apartment: '',
    City: '',
    Country: SessionUser.TenantCode.toUpperCase(),
    District: '',
    DoorNr: '',
    Neighborhood: '',
    PostCode: '',
    Region: '',
    Street: '',
    AddressTypeId: 1,
    AddressId: 0
  }

  const defaultServiceData = {
    serviceShopId: '',
    serviceShopDsc: '',
    serviceShopPhone: '',
    serviceShopConsumerId: ''
  }

  const defaultServiceAddressData = {
    AddressType: '',
    Address: '',
    State: '',
    AddressItem: '',
    Apartment: '',
    City: '',
    Country: SessionUser.TenantCode.toUpperCase(),
    District: '',
    DoorNr: '',
    Neighborhood: '',
    PostCode: '',
    Region: '',
    Street: '',
    Phone: '',
    Email: '',
    Name: '',
    ShipTo: '',
    Dsc: '',
    ServiceShopId: '',
    ConsumerAddressTypeId: 1,
    AddressId: 0
  }

  //-----------------------------------------------
  const [consumerData, setConsumerData] = useState(defaultConsumerData);
  const [serviceData, setServiceData] = useState(defaultServiceData);
  const [consumerAddressData, setConsumerAddressData] = useState(defaultConsumerAddressData);
  const [serviceAddressData, setServiceAddressData] = useState(defaultServiceAddressData);

  const isSending = useRef(false);

  const [tabsValue, setTabsValue] = React.useState(0);
  const handleChangetabs = (event, newValue) => {
    setTabsValue(newValue);
  };

  const handleClick = (obj, row) => {
    setConsumerData(cons => ({ ...cons, ...obj, }));
    setConsumerAddressData(row);
    setConsumerSearchPopUp(false);
  };

  const handleClickService = (obj, row) => {
    setServiceData(cons => ({ ...cons, ...obj, }));
    setServiceAddressData(row);
    setServiceShopSearchPopUp(false);
  };


  //-----------------CONSUMER ADDRESS------------------
  function setStreetData(newValue) {
    setServiceAddressData(prevAddressData => ({
      ...prevAddressData,
      Street: newValue
    }));
  }
  function setApartmentData(newValue) {
    setServiceAddressData(prevAddressData => ({
      ...prevAddressData,
      Apartment: newValue
    }));
  }
  function setAddressData(newValue) {
    setServiceAddressData(prevAddressData => ({
      ...prevAddressData,
      Address: newValue
    }));
  }
  function setStateData(newValue) {
    setServiceAddressData(prevAddressData => ({
      ...prevAddressData,
      State: newValue
    }));
  }
  function setAddressItemData(newValue) {
    setServiceAddressData(prevAddressData => ({
      ...prevAddressData,
      AddressItem: newValue
    }));
  }
  function setCityData(newValue) {
    setServiceAddressData(prevAddressData => ({
      ...prevAddressData,
      City: newValue
    }));
  }
  function setCountryData(newValue) {
    setServiceAddressData(prevAddressData => ({
      ...prevAddressData,
      Country: newValue
    }));
  }
  function setDistrictData(newValue) {
    setServiceAddressData(prevAddressData => ({
      ...prevAddressData,
      District: newValue
    }));
  }
  function setDoorNrData(newValue) {
    setServiceAddressData(prevAddressData => ({
      ...prevAddressData,
      DoorNr: newValue
    }));
  }
  function setNeighborhoodData(newValue) {
    setServiceAddressData(prevAddressData => ({
      ...prevAddressData,
      Neighborhood: newValue
    }));
  }
  function setPostCodeData(newValue) {
    setServiceAddressData(prevAddressData => ({
      ...prevAddressData,
      PostCode: newValue
    }));
  }
  function setRegionData(newValue) {
    setServiceAddressData(prevAddressData => ({
      ...prevAddressData,
      Region: newValue
    }));
  }
  function setEmailData(newValue) {
    setServiceAddressData(prevAddressData => ({
      ...prevAddressData,
      Email: newValue
    }));
  }
  function setPhoneData(newValue) {
    setServiceAddressData(prevAddressData => ({
      ...prevAddressData,
      Phone: newValue
    }));
  }
  function setNameData(newValue) {
    setServiceAddressData(prevAddressData => ({
      ...prevAddressData,
      Name: newValue
    }));
  }
  function setAddressTypeIdData(newValue) {
    setServiceAddressData(prevAddressData => ({
      ...prevAddressData,
      AddressTypeId: newValue
    }));
  }
  //-----------------------------------------

  const GetWorkOrderIdMandatoryControl = () => {
    var process = 'MaterialOrder';
    axios
      .get(`/GetWorkOrderIdMandatoryControl/${process}`)
      .then(response => {
        if (response.data.length > 0) {
          setWorkOrderIdControl(true);
        }
      })
      .catch(error => {
        setWorkOrderIdControl(false);
      });
  };

  const updateWorkOrder = statusId => {
    saveWorkOrder(statusId);
  };

  const ValidateFields = () => {
    const serviceIsNull = !!(
      serviceData.serviceShopId === '' ||
      serviceData.serviceShopId === undefined
    );

    const workOrderIdIsNull =
      (!workOrderIdControl)
        ? false
        : !!(
          MaterialOrderData.jobNumber === '' ||
          MaterialOrderData.jobNumber === undefined
        );

    const consumerIsNull = !!(
      serviceData.serviceShopConsumerId === '' ||
      serviceData.serviceShopConsumerId === undefined
    );
    const sparePartListIsEmpty = SparepartData.length === 0;

    if (
      serviceIsNull ||
      consumerIsNull ||
      workOrderIdIsNull ||
      sparePartListIsEmpty
    ) {
      return false;
    }

    return true;
  };
  const GetStorageLocation = () => {
    axios
      .get(`/GetMaterialOrderStorageLocation/${serviceData.serviceShopId != "" ? serviceData.serviceShopId : SessionUser.ServiceShopId}`)
      .then(response => {
        if (response.data.length > 0) {
          setStorageLocationData(response.data);
        }
      })
      .catch(error => { });
  };
  const handleChangeStorageLocation = event => {
    setMaterialOrderData({
      ...MaterialOrderData,
      storageLocationId: event.target?.value || ''
    });

    setStorageLocation(event.target.value);
  };
  async function saveWorkOrder(StatusId) {
    if (isSending.current) return;
    isSending.current = true;

    const response = await axios.get(`/GetWorkOrderStatus/${MaterialOrderData.jobNumber || 0}`);
    const fetchedWorkOrderStatus = response.data.length > 0 && response.data !== "" ? response.data : [];

    //If we have not entered a workorderId or if there is no such workOrderId in the system, we do not check.
    const isWorkOrderOpen = fetchedWorkOrderStatus?.length > 0 ? fetchedWorkOrderStatus[0]?.IsOpen : true;

    var foc = orderData ? orderData?.FreeOfCharge : false;

    if (!foc && !isWorkOrderOpen) {
      // If the work order is closed, we do not save the order and issue a warning
      setResponseType('error');
      setResponseDsc(t('lblIsOpenWorkOrder'));
      setOpenSnackbar(true);
      isSending.current = false;
      return;
    }

    const storageLocationIsNull = !!(storageLocation === '' || storageLocation === undefined || storageLocation === null || storageLocation === '0');
    if (IsHitachiCountry && storageLocationIsNull) {
      setResponseType('error');
      setResponseDsc(t('lblIsStorageLocation'));
      setOpenSnackbar(true);
      isSending.current = false;
      return;
    }
    if (ValidateFields()) {
      setLoading(true);
      const SetMaterialOrderDetailRequestDto = [];
      for (let i = 0; i < SparepartData.length; i++) {
        const tmpSparePartData = {
          MaterialOrderId: 0,
          ItemNr: SparepartData.map(x => x.MaterialId).indexOf(SparepartData[i].MaterialId),
          MaterialId: SparepartData[i].MaterialId,
          MaterialIdReplaced: 0,
          Qty: SparepartData[i].Quantity,
          ProductId: SparepartData[i].ProductId,
          ShipedQty: 0,
          MaterialOrderDetailStatusId: StatusId,
          ItemNote: ''
        };
        SetMaterialOrderDetailRequestDto.push(tmpSparePartData);
      }

      const SetMaterialOrderAddressRequestDto = [];
      const tmpSparePartData = {
        MaterialOrderId: 0,
        AddressType: serviceAddressData.ConsumerAddressTypeId,
        State: serviceAddressData.State,
        Address: serviceAddressData.Address,   //GetConsumerForMaterialOrder da AddressItem olarak GetServiceShopById ' de Address olarak geliyor 
        Apartment: serviceAddressData.Apartment,
        City: serviceAddressData.City,
        Country: serviceAddressData.Country,
        District: serviceAddressData.District,
        DoorNr: serviceAddressData.DoorNr,
        Neighborhood: serviceAddressData.Neighborhood,
        PostCode: serviceAddressData.PostCode,
        Region: serviceAddressData.Region,
        Street: serviceAddressData.Street,
        Email: serviceAddressData.Email,
        Phone: serviceAddressData.Phone,
        Name: serviceAddressData.Name,
        ServiceShopId: serviceAddressData.ServiceShopId
      };
      SetMaterialOrderAddressRequestDto.push(tmpSparePartData);

      const setMaterialRequestDto = {
        Id: MaterialOrderData.orderNumber == '' ? 0 : MaterialOrderData.orderNumber,
        MaterialOrderStatusId: StatusId,
        BillToOtc: 0,
        BillToConsumerId: 0,
        BillToServiceShopId: serviceData.serviceShopId,
        BillToRetailerId: 0,
        ShipToToOtc: 0,
        ShipToToConsumerId: 0,
        ShipToToServiceShopId: serviceAddressData.IsRetailer == 0 ? serviceAddressData.ServiceShopId : 0,
        ShipToToRetailerId: serviceAddressData.IsRetailer == 1 ? serviceAddressData.RetailerId : 0,
        OtcPhone: '',
        OtcPhone: '',
        OtcTaxOffice: '',
        OtcTaxNr: '',
        WorkOrderId: MaterialOrderData.jobNumber == '' ? 0 : MaterialOrderData.jobNumber,
        Dsc: MaterialOrderData.description,
        FreeOfCharge: orderData ? orderData?.FreeOfCharge ? 1 : 0 : 0,
        CreateDate: moment().format('YYYY-MM-DD'),
        LastUpdateEmployeeId: SessionUser.TechnicianId,
        PONumber: MaterialOrderData.poNumber,
        ErpDocumentNr: MaterialOrderData.sapNumber || null,
        SapShipToCode: serviceAddressData.SapShiptoCode ? serviceAddressData.SapShiptoCode : MaterialOrderData.sapShipToCode,
        SapStorageLocationCode: isRomania ? sapStorageLocationCode : '',
        StorageLocationId: storageLocation == '' ? 0 : storageLocation,
        MaterialOrderAddress: SetMaterialOrderAddressRequestDto,
        MaterialOrderDetails: SetMaterialOrderDetailRequestDto
      };

      const config = {
        headers: { 'Content-Type': 'application/json' }
      };

      //Russia-PricePreview Test Data
      // if (StatusId === 5) {

      //   const mockPricePreviewData = [
      //     {
      //       MaterialCode: "C00290451|11111111111|3334.55|RUB"
      //     },
      //     {
      //       MaterialCode: "C00290451|11111111112|111.55|RUB"
      //     },
      //     {
      //       MaterialCode: "C33333333|C33333333|1312.55|RUB"
      //     },
      //     {
      //       MaterialCode: "C00999999|22222222222|1200.00|RUB"
      //     }
      //   ];

      //   setPricePreviewData(mockPricePreviewData);
      //   setopenPricePreview(true);
      //   setLoading(false);
      //   isSending.current = false;
      //   return;
      // }

      axios
        .post('/SetMaterialOrder', setMaterialRequestDto, config)
        .then(response => {
          if (response.data.IsSuccess) {
            const tmpStatus = statusList.find(x => x.Id === StatusId).Name;
            const tmpStatusId = statusList.find(x => x.Id === StatusId).Id;
            setMaterialOrderData({
              ...MaterialOrderData,
              orderNumber: response.data.OrderNr,
              status: tmpStatus,
              sapNumber: response.data?.SapNr || ''
            });

            setCurrentStatus(StatusId);
            // Notify parent when order is cancelled so SAP send can be skipped
            if (StatusId === 2 && props && props.onCancel) {
              props.onCancel();
            }

            if (StatusId === 3 && props && props.onSapSent) {
              props.onSapSent();
            }

            // Russia Price Preview
            if (StatusId === 5) {
              const previewResult = response.data?.PricePreviewResult || [];

              const hasBusinessError = previewResult.some(
                x => x.ErrorCode !== null && x.ErrorCode < 0
              );

              const businessErrorMessage =
                previewResult.find(x => x.ErrorCode < 0)?.ErrorDescription;

              if (hasBusinessError) {
                setPricePreviewData([]);
                setPricePreviewError({
                  isApiSuccess: response.data.IsSuccess,
                  hasBusinessError: true,
                  errorMessage: businessErrorMessage
                });
                setopenPricePreview(true);
                setLoading(false);
                isSending.current = false;
                return;
              }

              if (previewResult.length > 0) {
                setPricePreviewData(previewResult);
                setPricePreviewError({
                  isApiSuccess: true,
                  hasBusinessError: false,
                  errorMessage: null
                });
                setopenPricePreview(true);
                setLoading(false);
                isSending.current = false;
                return;
              }
            }

            if (SessionUser.TenantId === 16 && tmpStatusId === 3) {
              GetMaterialOrderParam(response.data.OrderNr);
            }

            setResponseType('success');
            setResponseDsc(t('success_message'));
            setOpenSnackbar(true);
          } else if (response.data.ErrorMessage === 'IsSapCountryError') {
            setResponseType('error');
            setResponseDsc(t('lblIsSapCountryError'));
            setOpenSnackbar(true);
          } else {
            setResponseType('error');
            setResponseDsc(response.data.ErrorMessage);
            setOpenSnackbar(true);
          }
          setLoading(false);
          isSending.current = false;
        })
        .catch(error => {
          setLoading(false);
          isSending.current = false;
        });
    } else {
      handleSnackbarClick();
      isSending.current = false;
    }
  }

  const handleSnackbarClick = () => {
    setResponseType('error');
    if (SessionUser.TenantId == 82) {
      setResponseDsc(t('lblMissingFieldsHK'));
    } else {
      setResponseDsc(t('lblMissingFields'));
    }
    setOpenSnackbar(true);
  };

  const clearPage = () => {
    setMaterialOrderData(defaultMaterialOrder);
    setMaterialListData([]);
    setConsumerAddressData(defaultConsumerAddressData);
    setConsumerData(defaultConsumerData);
    setServiceData(defaultServiceData);
    setServiceAddressData(defaultServiceAddressData);
    setSparePartData([]);
    setQuerySearchScreenData([]);
    setCurrentRow('');
    setTotalSum("0.00");
    setVatRate("0.00");
    setVat("0.00");
    setPriceWithVAT("0.00");
    setSapStorageLocationCode('');
    setStorageLocationDialogOpen(false);
  };

  const GetMaterialOrderParam = (orderId) => {
    clearPage();
    setCurrentStatus(0);
    setQuerySearchData([]);
    setQuerySearchScreenData([]);
    setLoading(true);
    const StartDate = moment(StartDateSearch).format('YYYY-MM-DD');
    const EndDate = moment(EndDateSearch).format('YYYY-MM-DD');
    const Request = {
      StatusId: 0,
      StartDate,
      EndDate,
      ServiceShopId: serviceData.serviceShopId != "" ? serviceData.serviceShopId : SessionUser.ServiceShopId,
      OrderNr: SearchOrderParam ? SearchOrderParam : orderId
    };

    const RequestHeaders = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/GetMaterialOrder', Request, RequestHeaders)
      .then(response => {
        const Response = response.data;
        if (Response.length > -1) {
          setQuerySearchScreenData(Response);
          const tempData = Response[0];

          setQuery(tempData);
        } else {
          setQuerySearchScreenData([]);
        }
        setLoading(false);

      })
      .catch(error => {
        setQuerySearchScreenData([]);
        setLoading(false);
      });
  };




  useEffect(() => {
    setQuery(currentRow);
  }, [currentRow]);


  const setQuery = row => {
    if (row == "") {
      return;
    } else {
      const defaultMaterialOrderParam = {
        ServiceShopId: row.ServiceShopId,
        service: `${row.SourceServiceShopCode} ${row.ServiceShop}`,
        orderNumber: row.MaterialOrderId,
        orderDate: row.OrderDate,
        sapNumber: row.SapNr ? row.SapNr : '',
        jobNumber: row.WorkOrderId ? row.WorkOrderId : '',
        modelCode: '',
        status: row.MaterialOrderStatus,
        description: row.Dsc,
        poNumber: row.poNumber,
        sapShipToCode: row.SapShipToCode,
        storageLocationId: row.StorageLocationId
      };

      setSelectedValueFOC(row.FreeOfCharge === true ? 1 : 0);

      setServiceData({
        serviceShopId: row.ServiceShopId,
        serviceShopDsc: row.SourceServiceShopCode + '-' + row.ServiceShopDsc,
        serviceShopPhone: row.Phone,
        serviceShopConsumerId: row.ServiceConsumerId
      })

      setServiceAddressData({
        ConsumerAddressTypeId: row.AddressTypeId,
        Address: row.Address,
        State: row.State,
        Apartment: row.Apartment,
        City: row.City,
        Country: row.Country,
        District: row.District,
        DoorNr: row.DoorNr,
        Neighborhood: row.Neighborhood,
        PostCode: row.PostCode,
        Region: row.Region,
        Email: row.Email,
        Name: row.ConsumerFullName,
        Phone: row.Phone,
        ServiceShopId: row.ServiceShopId,
        Street: row.Street,
        ShipTo: row.ShipTo,
        SapShiptoCode: row.SapShipToCode
      });

      setConsumerData({
        consumerId: row.ConsumerId,
        consumerFullName: row.ConsumerFullName,
        consumerPhoneNumber: row.Phone
      });

      setAddressItemData(row.ConsumerAddress);
      setStateData(row.ConsumerState);
      setApartmentData(row.ConsumerApartment);
      setCityData(row.ConsumerCity);
      setCountryData(row.ConsumerCountry);
      setDistrictData(row.ConsumerDistrict);
      setDoorNrData(row.ConsumerDoorNr);
      setNeighborhoodData(row.ConsumerNeighborhood);
      setPostCodeData(row.ConsumerPostCode);
      setRegionData(row.ConsumerRegion);
      setStreetData(row.ConsumerStreet);
      setEmailData(row.Email);
      setPhoneData(row.Phone);
      setNameData(row.ConsumerFullName);
      setAddressTypeIdData(row.ConsumerAddressType);

      const DetailData = [];

      if (row.MaterialOrderDetails && Array.isArray(row.MaterialOrderDetails))
        row.MaterialOrderDetails.forEach(item => {
          const Data = {};
          Data.MaterialId = item.MaterialId;
          Data.MaterialCode = item.MaterialCode;
          Data.MaterialDesc = item.Material;
          Data.ItemNr = item.ItemNr;
          Data.Quantity = item.Qty;
          Data.UseQuantity = item.OriginalQty;
          Data.DiscountRatio = item.DiscountRatio;
          Data.Price = SessionUser.ServiceShopPriceVisible ? item.Price : 0;
          Data.PriceWithWat = SessionUser.ServiceShopPriceVisible ? item.PriceWithWat : 0;
          Data.Total = SessionUser.ServiceShopPriceVisible ? item.PriceWithWat * item.Qty : 0;
          Data.ProductId = item.ProductId
          Data.ProductName = item.ProductName
          Data.ItemNote = item.ItemNote
          Data.DiscountedPrice = item.DiscountedPrice
          Data.VAT = item.VAT
          Data.VATRate = item.VATRate
          DetailData.push(Data);

        });

      setCurrentStatus(row.StatusId);
      setMaterialOrderData(defaultMaterialOrderParam);
      setSparePartData(DetailData);
      setOrderData(row);
      setQueryPopUp(false);
      // setQuerySearchScreenData([]);
    }

  };

  const localeMap = {
    tr: trLocale
  };

  const locale = localStorage.getItem('i18nextLng');

  const siyah = '#424242';
  const materialTheme = createTheme({
    palette: {
      primary: {
        contrastText: '#FFFFFF',
        dark: siyah,
        main: siyah,
        light: siyah
      }
    }
  });

  function GetHistoricalBom(SKU, ProductYear, ProductMonth) {
    var ServiceShopId = SessionUser.ServiceShopId;
    setMaterialListData([]);
    setLoading(true);
    axios
      .get(`/GetHistoricalBom/${SKU}/${ProductMonth || 0}/${ProductYear || 0}/${ServiceShopId}`)
      .then(response => {
        var data = response.data;
        if (data.length > 0) {
          setLoading(false);
          setBomData(data);
          setMaterialListData(response.data);
        }
      })
      .catch(error => {
        setLoading(false);
        setMaterialListData([]);
        setResponseType('error');
        setResponseDsc(t('lblError'));
        setOpenSnackbar(true)
      });
  }


  const SetDate = value => {
    const DateValue = moment(value).format('YYYY-MM-DD');
    setMaterialOrderData({ ...MaterialOrderData, orderDate: DateValue });
  };


  const getSpareUserColor = s => {
    if (s.Quantity !== "0,0") {
      return (
        <Avatar
          size="small"
          style={{ color: 'white', backgroundColor: 'green' }}
        >
          <AccountCircleIcon />
        </Avatar>
      );
    } else {
      return (
        <Avatar
          size="small"

          style={{ color: '#424242', backgroundColor: 'red' }}
        >
          <AccountCircleIcon />
        </Avatar>
      );
    }
  };

  const getHitachiCountry = () => {
    axios
      .get(
        `/GetLoanProductCountry/${parseInt(SessionUser.TenantId)}`
      )
      .then(response => {
        if (response.data == false) {
          setIsHitachiCountry(false);
        } else {
          setIsHitachiCountry(true);
        }
      })
      .catch(error => {
      });
  };

  const ErpStatusPopup = (ErpNr) => {
    setLoading(true);
    setErpStatusOpen(true);

    axios
      .get('/GetErpWarehouseMaterialStatus/' + ErpNr + '/' + localStorage.getItem('i18nextLng'))
      .then(response => {
        const res = response.data.length === 0 ? [] : response.data;
        setErpStatusData(res);
      })
      .catch(error => {
        setErpStatusData([]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const ErpStatusPopupS4HANA = (ErpNr) => {
    setLoading(true);
    setErpStatusOpen(true);

    const Request = { ErpDocNumber: ErpNr };
    const RequestHeaders = { headers: { 'Content-Type': 'application/json' } };

    axios
      .post('/SparePartOrderingStatus', Request, RequestHeaders)
      .then(response => {
        const res = response.data.length === 0 ? [] : response.data;
        setErpStatusData(res);
      })
      .catch(error => {
        setErpStatusData([]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const exportMaterialData = (data) => {
    var json = []
    for (let i = 0; i < data?.length; i++) {
      var temp = {};
      temp.ProductId = data[i].ProductId;
      temp.MaterialCode = data[i].MaterialCode;
      temp.MaterialDesc = data[i].MaterialDesc;
      temp.Ref = data[i].Ref;
      temp.lblQuantity = data[i].Quantity;
      temp.UseQuantity = data[i].UseQuantity;
      temp.DiscountRatio = data[i].DiscountRatio;
      temp.Price = SessionUser.ServiceShopPriceVisible ? data[i].Price : 0;
      temp.PriceWithWat = SessionUser.ServiceShopPriceVisible ? data[i].PriceWithWat : 0;
      temp.lblTotal = SessionUser.ServiceShopPriceVisible ? data[i].Total : 0;
      json.push(temp)
    };

    return json
  };

  const exportExcelExample = [{
    'MaterialCode': '',
    'Quantity': ''
  }];
  const CreditLimitNote = (ServiceShopId) => {
    setCreditLimitOpen(true);
    setLoading2(true);
    const Request = { ServiceShopId: ServiceShopId };
    const RequestHeaders = { headers: { 'Content-Type': 'application/json' } };

    axios
      .post('/GetCreditLimit', Request, RequestHeaders)
      .then(response => {
        try {
          if (response.data.length > 0 && response.data[0]?.IsSuccess) {
            debugger;
            setCreditLimitData(response.data[0]);
          }
          else {
            setCreditLimitData(null);
          }
        } catch (err) {
          console.error("JSON Parse Hatası:", err);
          setCreditLimitData(null);
        }
      })
      .catch(error => {
        console.error("API Hatası:", error);
        setCreditLimitData(null);
      })
      .finally(() => {
        setLoading2(false);
      });
  };


  const deleteFromMaterialTable = row => {
    setSparePartData(prev =>
      prev.filter(item => item.MaterialId !== row.MaterialId)
    );
  };

  const StokControlPopup = (row) => {
    setStockDataLoading(true);
    setStokData([]);
    const Request = {
      MaterialCode: [row.MaterialCode],
      ServiceShopCode: SessionUser.ServiceShopCode
    };

    const RequestHeaders = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/GetMaterialAvailabilitySirius', Request, RequestHeaders)
      .then(response => {
        const res = response.data.length === 0 ? [] : response.data;
        const stokQuantity = res.map(item => ({
          ...item,
          Quantity: parseInt(item.Quantity, 10)
        }));
        setStokData(stokQuantity);
        setMaterialAvailabilityCode(row.MaterialCode);
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      })
      .finally(() => {
        setStockDataLoading(false);
      });
    setStokOpen(true);
    setShowVirtualDetail(false);
    if (SessionUser.TenantId !== 49) {
      GetMaterialAvailabilityOwnEngineer(row, false);
    }
    if (virtualStockEnabled) {
      setVirtualLoading(true);
      GetVirtualStockAvailability(SessionUser.ServiceShopCode, row.MaterialCode);
    }
    else {
      setVirtualTotal(0);
      setVirtualInvoices([]);
      setVirtualLoading(false);
    }
    setRowData(row);
  }

  const GetMaterialAvailabilityOwnEngineer = (row, value) => {
    if (SessionUser.TenantId === 49) {
      return;
    }

    setIsAllOwnEngineer(value);
    setLoading2(true);
    const Request = {
      MaterialCode: [row.MaterialCode],
      ServiceShopId: SessionUser.ServiceShopId,
      IsAllOwnEngineer: value
    };
    const RequestHeaders = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/GetMaterialAvailabilityOwnEngineer', Request, RequestHeaders)
      .then(response => {
        const res = response.data.length === 0 ? [] : response.data;
        if (res.length > 0) {
          const stokQuantity = res.map(item => ({
            ...item,
            Quantity: parseInt(item.Quantity, 10)
          }));
          setStokDataOwnEngineer(stokQuantity);
          setServiceShopTypeId(res[0].ServiceShopTypeId);
        }
        else {
          setStokDataOwnEngineer([]);
          setStockMsg(t('lblStockMsg'))
        }

        setLoading2(false);
      })
      .catch(error => {
        setLoading2(false);
      });
  }

  const GetVirtualStockAvailability = (serviceShopCode, materialCode) => {
    const RequestHeaders = { headers: { 'Content-Type': 'application/json' } };

    setVirtualLoading(true);

    axios
      .post('/GetVirtualStockAvailability',
        { ServiceShopCode: serviceShopCode, MaterialCode: materialCode },
        RequestHeaders
      )
      .then(res => {
        setVirtualTotal(res.data?.TotalAvailableQty ?? 0);
        setVirtualInvoices(res.data?.Invoices ?? []);
        setVirtualLoading(false);
      })
      .catch(() => {
        setVirtualTotal(0);
        setVirtualInvoices([]);
        setVirtualLoading(false);
      });
  };

  const StockSearch = () => {
    if (SessionUser.TenantId !== 49) {
      GetMaterialAvailabilityOwnEngineer(rowData, true);
    }
    setBackButtonVisible(true);
  }
  const handleBackButtonClick = () => {
    setBackButtonVisible(false);
    if (SessionUser.TenantId !== 49) {
      GetMaterialAvailabilityOwnEngineer(rowData, false);
    }
  };

  function setQuantityNum(value, id) {
    const tmpListData = [...SparepartData];
    const index = tmpListData.findIndex(x => x.MaterialId === id);
    tmpListData[index].Quantity = value;
    tmpListData[index].Total = tmpListData[index].Quantity * tmpListData[index].PriceWithWat;
    setSparePartData(tmpListData);
  }

  function setProductMaterial(materialData) {
    if (UrunData.Model && UrunData.ModelCode) {
      if (UrunData.ProductId >= 1000000) {
        setMaterialListData([]);
        materialData.ProductId = UrunData.ProductId
        materialData.ProductName = UrunData.Model
        let result = []
        result.push(materialData)
        setMaterialListData(result);
        setinitialRows(result);
      }
    }
    else {
      setResponseType('error');
      setResponseDsc(t('lblChooseProduct'));
      setOpenSnackbar(true)
    }

  }

  const requestSearch = (searchedVal) => {
    const lowerCaseSearchVal = searchedVal.toLowerCase();
    const filteredRows = initialRows.filter((item) => {
      return (
        item.MaterialCode.toLowerCase().includes(lowerCaseSearchVal) ||
        item.MaterialDesc.toLowerCase().includes(lowerCaseSearchVal) ||
        item.Ref.toLowerCase().includes(lowerCaseSearchVal) ||
        item.PriceWithWat.toFixed(2).toLowerCase().includes(lowerCaseSearchVal)
      );
    });
    setMaterialListData(filteredRows);
    setPage(0);
  };

  const requestSearch2 = (searchedVal) => { //Only Material -Material Search
    const lowerCaseSearchVal = searchedVal.toLowerCase();
    const filteredRows = initialRows.filter((item) => {
      return (
        item.MaterialCode.toLowerCase().includes(lowerCaseSearchVal) ||
        item.MaterialDesc.toLowerCase().includes(lowerCaseSearchVal) ||
        item.Ref.toLowerCase().includes(lowerCaseSearchVal) ||
        item.PriceWithWat.toFixed(2).toLowerCase().includes(lowerCaseSearchVal)
      );
    });
    setMaterialListData2(filteredRows);
    setPage(0);
  };

  const cancelSearch = () => {
    setSearched('');
    requestSearch(searched);
  };

  const malzemeGosterMaterial = materialCode => {
    const data = {
      MaterialCode: materialCode
    };
    const config = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/FileImportExport/SiriusMaterialImage', data, config)
      .then(response => {
        const fileURL = URL.createObjectURL(response.data);

        // newWindow.location = fileURL;
        // newWindow.document.title = materialCode;
        setImageUrl(fileURL);
        setImagePopup(true);
      })
      .catch(error => { });
  };

  const addToMaterialTable = row => {
    setSparePartData(prev => {
      const exists = prev.find(x => x.MaterialId === row.MaterialId);
      if (exists) {
        return prev.map(item =>
          item.MaterialId === row.MaterialId
            ? {
              ...item,
              Quantity: item.Quantity + 1,
              Total: (item.Quantity + 1) * item.PriceWithWat
            }
            : item
        );
      } else {
        return [
          ...prev,
          {
            ...row,
            Quantity: 1,
            Total: row.PriceWithWat
          }
        ];
      }
    });
  };



  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };


  const GetSiriusMaterialsBySearchKey = (equivalent, materialCode) => {
    const Request = {
      SearchParam: equivalent.toLocaleLowerCase(localStorage.i18nextLng_normalized),
      ServiceShopId: SessionUser.ServiceShopId
    };
    setLoading(true);

    const RequestHeaders = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/GetSiriusMaterialsBySearchKey', Request, RequestHeaders)
      .then(response => {
        setLoading(false);
        if (response.data.length > 0) {
          setEquivalentData(response.data);
          MuadilMalzemeGoster(equivalent, materialCode);
        } else {
          setEquivalentData([]);
          const informationAlert = t('lblMissingMaterial');
          setUyari(informationAlert);
          setopenWarning(true);
        }
      })
      .catch(error => {
        setLoading(false);
      });
  }

  const GetSiriusActiveEquivalentMaterialCodes = (materialCode) => {
    const RequestHeaders = {
      headers: { 'Content-Type': 'application/json' }
    };
    setLoading(true);
    axios
      .get(`/GetSiriusActiveEquivalentMaterialCodes/${materialCode}/${SessionUser.ServiceShopId}`, RequestHeaders)
      .then(response => {
        setLoading(false);
        if (response.data.length > 0) {
          let searchParam = response.data.toString();
          setEquivalentData(response.data);
          MuadilMalzemeGoster(searchParam, materialCode);
        } else {
          const informationAlert = t('lblMissingMaterial');
          setUyari(informationAlert);
          setopenWarning(true);
        }
      })
      .catch(error => { setLoading(false); });
  }

  const setSearchMaterial = () => {
    setMaterialListData2([]);

    const Request = {
      SearchParam: inputText.toLocaleLowerCase(localStorage.i18nextLng_normalized),
      ServiceShopId: SessionUser.ServiceShopId
    };
    setLoading(true);

    const RequestHeaders = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/GetSiriusMaterialsBySearchKey', Request, RequestHeaders)
      .then(response => {
        setLoading(false);
        if (response.data.length > 0) {
          setMaterialListData2(response.data);
          setinitialRows(response.data);
        } else {
          setMaterialListData2([]);
          const informationAlert = t('lblMissingMaterial');
          setUyari(informationAlert);
          setopenWarning(true);
        }
      })
      .catch(error => {
        setLoading(false);
      });
  }

  const setModel = (param) => {
    setMaterialListData([]);

    const job = {
      ModelCode: param.KUL_MODEL_KODU,
      Model: param.ACIKLAMA,
      HomeWhiz: param.HOMEWHIZ,
      BrandCode: param.MARKA_KODU,
      ProductId: param.MODEL_KODU
    };

    setUrunData(job);

    const Request = {
      SearchParam: param.KUL_MODEL_KODU,
      ServiceShopId: SessionUser.ServiceShopId
    };
    setLoading(true);

    const RequestHeaders = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/GetSiriusMaterialsBySearchKey', Request, RequestHeaders)
      .then(response => {
        setLoading(false);
        if (response.data.length > 0) {
          setMaterialListData(response.data);
          setinitialRows(response.data);
        } else {
          setMaterialListData([]);
          const informationAlert = t('lblMissingMaterial');
          setUyari(informationAlert);
          setopenWarning(true);
        }
      })
      .catch(error => {
        setLoading(false);
      });
  }

  const handleChange = event => {
    setInputText(event.target.value);
  }

  // Import excel function
  function setSearcByExcelhMaterial(excelData) {
    setMaterialListData2([]);

    setLoading(true);

    const request = {
      ExcelDataFormat: excelData,
      ServiceShopId: JSON.stringify(SessionUser.ServiceShopId)
    }
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };

    // A comparer used to determine if two entries are equal.
    const isSameMaterial = (a, b) => a.MaterialCode === b.MaterialCode;

    const onlyInLeft = (left, right, compareFunction) =>
      left.filter(leftValue =>
        !right.some(rightValue =>
          compareFunction(leftValue, rightValue)));

    axiosServiceShop // service shop url
      .post('/ServiceShop/GetSiriusMaterialByExcelData', request, config)
      .then(response => {
        setLoading(false);
        if (response.data.length > 0) {
          response.data.forEach(element => {
            const excelItem = excelData.find(e => e.MaterialCode === element.MaterialCode);
            if (excelItem) {
              element.Quantity = excelItem.Quantity;
            }
            element.Total = element.Quantity * element.PriceWithWat;
          });

          var missingValues = onlyInLeft(excelData, response.data, isSameMaterial);

          setMaterialListData2(response.data); // Material Choose popup
          setSparePartData(response.data); // Table
          setinitialRows(response.data);

          if (missingValues.length > 0) {
            missingMaterials(missingValues);
            missingMaterialsPopUp(true);
          }

          setSelectedMaterialPopup(false); // Close popup
        } else {
          setMaterialListData([]);
        }
      })
      .catch(error => {
        setLoading(false);
      });
  }

  const getExention = (file) => {
    const parts = file.name.split('.')
    const extension = parts[parts.length - 1]
    return EXTENSIONS.includes(extension) // return boolean
  }

  const importExcel = (e) => {
    const file = e.target.files[0]
    const reader = new FileReader()
    if (file) {
      setLoading(true)
      if (getExention(file)) {
        reader.readAsBinaryString(file)
      }
      reader.onload = (event) => {
        //parse data
        const bstr = event.target.result
        const workBook = XLSX.read(bstr, { type: "binary" })
        //get first sheet
        const workSheetName = workBook.SheetNames[0]
        const workSheet = workBook.Sheets[workSheetName]
        //convert to array
        const fileData = XLSX.utils.sheet_to_json(workSheet, { header: 1 })
        // Create excel data array
        var excelData = [];

        for (var i = 1; i < fileData.length; i++) {
          // Check related row data is empty or quantity is valid
          if ((fileData[i][0] !== undefined && fileData[i][0] !== null && String(fileData[i][0]).trim() !== '') && (fileData[i][1] !== undefined && fileData[i][1] !== null && String(fileData[i][1]).trim() !== '' && !isNaN(+String(fileData[i][1])) && parseInt(String(fileData[i][1])) > 0)) {
            var quantity = parseInt(String(fileData[i][1])) > 999 ? '999' : String(fileData[i][1])
            // Add array to related row
            excelData.push({ MaterialCode: String(fileData[i][0]), Quantity: quantity })
          }
        }

        if (excelData.length > 0) {
          // Get related material
          setSearcByExcelhMaterial(excelData);
        }
      }
    }
  }

  const handleCloseEdit = value => {
    setOpenEdit(false);
  }

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackbar(false);
  };


  const GetMaterialOrderRequest = () => {
    if (!serviceShopId?.ServiceShopId) {
      return
    }
    setQuerySearchData([]);
    setQuerySearchScreenData([]);
    setLoading(true);
    const StartDate = moment(StartDateSearch).format('YYYY-MM-DD');
    const EndDate = moment(EndDateSearch).format('YYYY-MM-DD');
    const Request = {
      StatusId: selectedStatus.Id,
      StartDate,
      EndDate,
      ServiceShopId: serviceShopId.ServiceShopId,
      OrderNr: MaterialOrderData.orderNumber | 0,
      SapNr: MaterialOrderData.sapNumber
    };

    const RequestHeaders = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/GetMaterialOrder', Request, RequestHeaders)
      .then(response => {
        const Response = response.data;
        if (Response.length > 0) {
          setQuerySearchScreenData(Response);
        } else {
          setQuerySearchScreenData([]);
          setResponseType('warning');
          setResponseDsc(t('lblNoFoundOrder'));
          setOpenSnackbar(true);
        }
        setLoading(false);
      })
      .catch(error => {
        setQuerySearchScreenData([]);
        setLoading(false);
        setResponseType('error');
        setResponseDsc(t('lblError'));
        setOpenSnackbar(true);
      });
  };

  const getStokColor = s => {
    if (s.Quantity !== "0,0" && s.Quantity !== 0) {
      return (
        <Avatar
          size="small"
          style={{ color: 'white', backgroundColor: 'green' }}
        >
          <ShoppingCartIcon />
        </Avatar>
      );
    } else {
      return (
        <Avatar
          size="small"

          style={{ color: '#424242', backgroundColor: 'red' }}
        >
          <ShoppingCartIcon />
        </Avatar>
      );
    }
  };

  const exportData = (data) => {
    var json = []

    data.map(row => (
      row.MaterialOrderDetails ? row.MaterialOrderDetails.map(det => {
        var temp = {};
        temp.lblWorkOrderId = row.WorkOrderId;
        temp.lblServiceShop = `${row.SourceServiceShopCode} ${row.ServiceShop}`;
        temp.lblMaterialOrderId = row.MaterialOrderId;
        temp.lblRecipientDsc = row.RecipientDsc;
        temp.lblRecipientAddress = row.RecipientAddress;
        temp.lblRecipientId = row.RecipientId;
        temp.lblMaterialCode = det.MaterialCode;
        temp.lblMaterial = det.Material;
        temp.lblQuantity = det.Qty;
        temp.lblModelCode = det.ModelCode;
        temp.lblProductName = det.ProductName;
        temp.lblSapNr = row.SapNr;
        temp.lblOrderDate = row.OrderDate === undefined ? '' : SessionUser.TenantId == 79 ? moment(row.OrderDate).format('MM/DD/YYYY HH:mm') : moment(row.OrderDate).format('DD/MM/YYYY HH:mm');
        temp.lblMaterialOrderStatus = row.MaterialOrderStatus;
        temp.lblWorkOrderStatus = row.WorkOrderStatus;
        temp.lblDescription = row.Dsc;
        temp.lblTotalPrice = SessionUser.ServiceShopPriceVisible ? moneyFormat(
          det.PriceWithWat,
          SessionUser.TenantCode,
          SessionUser.CurrencyUnit
        ) : 0 + `${SessionUser.CurrencyUnit}`;
        json.push(temp)
      }
      ) : null))

    return json
  }

  const GetMaterialOrderParamNew = (OrderId) => {
    clearPage();
    setCurrentStatus(0);
    setQuerySearchData([]);
    setQuerySearchScreenData([]);
    setLoading(true);
    const StartDate = moment(StartDateSearch).format('YYYY-MM-DD');
    const EndDate = moment(EndDateSearch).format('YYYY-MM-DD');
    const Request = {
      StatusId: 0,
      StartDate,
      EndDate,
      ServiceShopId: SessionUser.ServiceShopId,
      OrderNr: OrderId
    };

    const RequestHeaders = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/GetMaterialOrder', Request, RequestHeaders)
      .then(response => {
        const Response = response.data;
        if (Response.length > -1) {
          setQuerySearchScreenData(Response);
          setQuery(Response[0]);
        } else {
          setQuerySearchScreenData([]);
        }
        setLoading(false);

      })
      .catch(error => {
        setQuerySearchScreenData([]);
        setLoading(false);
      });
  };

  const GetServiceShopByTenant = () => {
    setLoading(true);

    axios
      .get(`/GetServiceShopByTenant`)
      .then(response => {
        setLoading(false);
        if (response.data.length > 0) {
          setServiceShopData(response.data);
          setServiceShopId(response.data[0]);
        } else {
          setServiceShopData([]);
          setResponseType('warning');
          setResponseDsc(t('lblNoFoundServiceShop'));
          setOpenSnackbar(true);
        }
      })
      .catch(error => {
        setLoading(false);
      });
  }

  useEffect(() => {
    GetServiceShopByTenant();
    getHitachiCountry();
    GetWorkOrderIdMandatoryControl();
    GetStorageLocation();
  }, []);

  useEffect(() => {
    if (StorageLocationData.length > 0) {
      if (MaterialOrderData?.storageLocationId) {
        setStorageLocation(MaterialOrderData.storageLocationId);
        setIsDisabled(StorageLocationData.length === 1);
      } else {
        if (StorageLocationData.length === 1) {
          setStorageLocation(StorageLocationData[0].Id);
          setIsDisabled(true);
        } else {
          setStorageLocation("");
          setIsDisabled(false);
        }
      }
    }
  }, [MaterialOrderData, StorageLocationData]);

  const blockInvalidChar = e => ['e', 'E', '+', '-', '.'].includes(e.key) && e.preventDefault();




  const highlight = text => {
    return (
      <Highlighter
        searchWords={[]}
        autoEscape
        textToHighlight={text}
      />
    );
  };

  const MuadilMalzemeGoster = (txt, malzeme) => {
    setMuadilParam(txt);
    setMuadilTitle(malzeme);
    setMuadilOpen(true);
  };


  const getMaterialRow = (row, index) => {

    if (row === undefined) {
      return '';
    }
    const rowI = row[index];
    if (rowI === undefined) {
      return '';
    }
    const labelId = `enhanced-table-checkbox-${index}`;
    const isItemSelected = SparepartData.some(x => x.MaterialCode == rowI.MaterialCode);
    const disabled = !isItemSelected;
    return (
      <TableRow
        role="checkbox"
        aria-checked={isItemSelected}
        tabIndex={-1}
        selected={isItemSelected}
        key={index}
      >
        <TableCell className={classes.tableCell}>
          {
            rowI.HistoricalBom === 0
              ? <AiOutlineCheckSquare style={{ color: 'green' }} size="20" />
              : <FaTree style={{ color: 'orange' }} size="20" />
          }
        </TableCell>
        <TableCell className={classes.tableCell}>
          <TrackChangesIcon
            onClick={() => { GetSiriusActiveEquivalentMaterialCodes(rowI.MaterialCode) }}
            color="primary"
          >
          </TrackChangesIcon>
        </TableCell>
        <TableCell className={classes.tableCell}>
          <ImageSearchIcon
            onClick={() => malzemeGosterMaterial(rowI.MaterialCode)}
            color="primary"
          >
          </ImageSearchIcon>
        </TableCell>
        <TableCell
          scope="row"
          onClick={() =>
            addToMaterialTable(rowI)}
        >
          <Grid container spacing={0}>
            <Grid
              style={{ color: rowI.CanBeOrdered ? 'inherit' : 'red' }}
              item
              xs={12}
            >
              <b>{highlight(rowI.MaterialCode)}</b>
              {' '}
              {highlight(rowI.MaterialDesc)}
            </Grid>
          </Grid>
        </TableCell>
        <TableCell className={classes.tableCell}>
          <b>
            <Chip
              size="small"
              label={`${moneyFormat(
                rowI.Price,
                SessionUser.TenantCode,
                SessionUser.CurrencyUnit
              )} ${SessionUser.CurrencyUnit}`}
            />
          </b>
        </TableCell>
        <TableCell className={classes.tableCell} align="right">
          <b>{'%' + (rowI.VatRate * 100).toFixed(2)}</b>
        </TableCell>
        <TableCell className={classes.tableCell}>
          <b>
            <Chip
              size="small"
              label={`${moneyFormat(
                rowI.PriceWithWat,
                SessionUser.TenantCode,
                SessionUser.CurrencyUnit
              )} ${SessionUser.CurrencyUnit}`}
            />
          </b>
        </TableCell>
        <TableCell className={classes.tableCell}>
          <b>Ref:{highlight(rowI.Ref)}</b>
        </TableCell>
        <TableCell
          padding="checkbox"
          onClick={() =>
            addToMaterialTable(rowI)}
        >
          <Checkbox
            checked={isItemSelected}
            inputProps={{ 'aria-labelledby': labelId }}
            color="primary"
            disabled={disabled}
          />
        </TableCell>
      </TableRow>
    );
  };

  const updateData = (data, rowToUpdate, quantity, priceWithVat) => {
    const index = data.findIndex(item => item.MaterialId === rowToUpdate.MaterialId);

    if (index >= 0) {
      return data.map(item =>
        item.MaterialId === rowToUpdate.MaterialId
          ? {
            ...item,
            Quantity: quantity,
            Total: quantity * priceWithVat,
            Qty: quantity,
            PriceWithWat: priceWithVat
          }
          : item
      );
    } else {
      return [
        ...data,
        {
          ...rowToUpdate,
          Quantity: quantity,
          Total: quantity * priceWithVat,
          Qty: quantity,
          PriceWithWat: priceWithVat
        }
      ];
    }
  };


  const handleQuantityChange = (e, row) => {
    const qty = Math.max(0, Math.min(999, Number(e.target.value) || 0));
    setSparePartData(prev =>
      prev.map(item =>
        item.MaterialId === row.MaterialId
          ? {
            ...item,
            Quantity: qty,
            Total: qty * item.PriceWithWat
          }
          : item
      )
    );
  };

  const getSafeNumber = (value) => {
    if (value === null || value === undefined) return 0;
    const num = parseFloat(value);
    return isNaN(num) ? 0 : num;
  };
  useEffect(() => {
    if (!Array.isArray(SparepartData) || SparepartData.length === 0) {
      setTotalSum('0.00');
      setVatRate('0.00');
      setVat('0.00');
      setPriceWithVAT('0.00');
      return;
    }


    const result = SparepartData.reduce((acc, item) => {
      const quantity = getSafeNumber(item.Quantity);
      const price = getSafeNumber(item.Price);
      const discountedPrice = getSafeNumber(item.DiscountedPrice);

      const vatRateRaw = item.VatRate !== undefined ? item.VatRate : item.VATRate;
      const vatRate = getSafeNumber(vatRateRaw);
      const netPrice = discountedPrice > 0 ? discountedPrice : price;
      const lineTotal = netPrice * quantity;
      const lineVatAmount = lineTotal * vatRate;

      acc.sum += lineTotal;
      acc.totalVat += lineVatAmount;
      acc.uniqueRates.add(vatRate);

      return acc;
    }, { sum: 0, totalVat: 0, uniqueRates: new Set() });

    const totalWithVat = result.sum + result.totalVat;
    setTotalSum(result.sum.toFixed(2));
    setVat(result.totalVat.toFixed(2));
    setPriceWithVAT(totalWithVat.toFixed(2));

    // Eğer kümede sadece 1 tane değer varsa (Örn: Hepsi %10 ise), o değeri göster.
    // Eğer kümede birden fazla değer varsa (Örn: %10 ve %8 karışık), boş bırak.
    if (result.uniqueRates.size === 1) {
      const singleRate = [...result.uniqueRates][0];
      setVatRate((singleRate * 100).toFixed(2));
    } else {
      setVatRate('');
    }
  }, [SparepartData]);


  return (
    <Page>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          message={ResponseDsc}
          variant={ResponseType}
        />
      </Snackbar>
      <Container maxWidth="xl">
        <Breadcrumbs>
          <Link color="inherit">Sirius</Link>
          <Typography color="textPrimary">{t('Material_Order')}</Typography>
          <Typography color="textPrimary">{t('Create')}</Typography>
          <Typography color="textPrimary">{t('ForPartner')}</Typography>
        </Breadcrumbs>
        <Card>
          <BottomNavigation
            value={TopBarValue}
            className={classes.stickToBottom}
            onChange={(event, newValue) => {
              setTopBarValue(newValue);

              switch (newValue) {
                case 0:
                  // SAVE
                  saveWorkOrder(1);
                  break;

                case 1:
                  // NEW ORDER
                  clearPage();
                  setCurrentStatus(0);
                  break;

                case 2:
                  // CANCEL
                  updateWorkOrder(2);
                  break;

                case 3:
                  // SEND TO SAP
                  if (isRomania && !sapStorageLocationCode) {
                    setResponseType('error');
                    setResponseDsc(t('SapStorageLocationRequired', {
                      defaultValue: 'Select a storage location before sending the order to SAP.'
                    }));
                    setOpenSnackbar(true);
                    return;
                  }
                  if (isSapButtonDisabled) return;
                  setIsSapButtonDisabled(true);
                  setTimeout(() => {
                    setIsSapButtonDisabled(false);
                  }, 3000);
                  updateWorkOrder(3);
                  break;

                case 4:
                  // STORAGE LOCATION (ROMANIA)
                  setStorageLocationDialogOpen(true);
                  break;

                case 5:
                  // PRICE PREVIEW (RUSSIA)
                  updateWorkOrder(5);
                  break;

                default:
                  console.warn("Unhandled action value:", newValue);
                  break;
              }
            }}
            showLabels
          >
            {/* SAVE */}
            {currentStatus !== 3 && (
              <BottomNavigationAction
                label={t('lblSave')}
                icon={<SaveIcon />}
                value={0}
              />
            )}

            {/* NEW ORDER */}
            <BottomNavigationAction
              label={t('lblNewOrder')}
              icon={<AddShoppingCartIcon />}
              value={1}
            />

            {/* CANCEL */}
            {(currentStatus === 1 || (SessionUser?.IsIhpTenant && [1, 3, 4].includes(currentStatus))) && (
              <BottomNavigationAction
                label={t('lblCancel')}
                icon={<CancelIcon />}
                value={2}
              />
            )}

            {/* SEND TO SAP */}
            {[1, 4, 5].includes(currentStatus) && (
              <BottomNavigationAction
                label={t('lblSendToSap')}
                icon={<SendIcon />}
                value={3}
                disabled={isSapButtonDisabled || (isRomania && !sapStorageLocationCode)}
              />
            )}

            {/* STORAGE LOCATION - only for Romania (TenantId = 49) */}
            {isRomania && (
              <BottomNavigationAction
                label={t('SapStorageLocation', { defaultValue: 'Storage Location' })}
                icon={<LocalGroceryStoreIcon />}
                value={4}
                disabled={!isStorageLocationButtonEnabled}
              />
            )}

            {/* PRICE PREVIEW – only for Russia (TenantId = 118) */}
            {[1, 5].includes(currentStatus) && [118, 119, 120, 121, 122].includes(SessionUser.TenantId) && (
              <BottomNavigationAction
                label={t('lblPricePreview')}
                icon={<VisibilityIcon />}
                value={5}
              />
            )}
          </BottomNavigation>
        </Card>
        <Divider />
        <Card>
          <CardHeader title={t('lblMaterialOrderInformation')}
            action={
              <Paper className={classes.searchB} elevation={1}>
                <Input
                  className={classes.searchInputB}
                  disableUnderline
                  onChange={(event) => {
                    setSearchOrderParam(event.target.value);
                  }}
                  placeholder={t('lblOrderNumber')}
                />
                <SearchIcon
                  onClick={() => GetMaterialOrderParam()}
                  className={classes.searchIconB}
                />
              </Paper>
            }
          />
          <Divider />
          <CardContent>
            <Grid container row spacing={1}>
              <Grid container item xs={12} sm={8} lg={8} spacing={1}>
                {/* orderNumber p-1*/}
                <Grid item xs={12} sm={6} lg={6}>
                  <Card>
                    <CardContent className={classes.cardscontent}>
                      <Grid container spacing={1}>
                        <Grid item xs={5} sm={5} lg={5}>
                          <TextField
                            size="small"
                            id="orderNumber"
                            disabled
                            autoComplete="no"
                            value={MaterialOrderData.orderNumber}
                            onChange={event =>
                              setMaterialOrderData({
                                ...MaterialOrderData,
                                orderNumber: event.target.value
                              })}
                            fullWidth
                            label={t('lblOrderNumber')}
                            variant="outlined"
                          />
                        </Grid>
                        <Grid item xs={5} sm={5} lg={5}>
                          <TextField
                            size="small"
                            id="sapNumber"
                            disabled
                            autoComplete="no"
                            value={MaterialOrderData.sapNumber}
                            onChange={event =>
                              setMaterialOrderData({
                                ...MaterialOrderData,
                                sapNumber: event.target.value
                              })}
                            fullWidth
                            label={t('lblSapNumber')}
                            variant="outlined"
                          />
                        </Grid>
                        <Grid item xs={1} sm={1} lg={1}>
                          {MaterialOrderData.sapNumber !== "" ?
                            <FormControlLabel
                              control={
                                <Box p={0.8}>
                                  <ControlCameraIcon
                                    size="small"
                                    color="primary"
                                    style={{ color: '#3399FF' }}
                                    onClick={() => {
                                      if (IsHitachiCountry) {
                                        ErpStatusPopupS4HANA(MaterialOrderData.sapNumber);
                                      } else {
                                        ErpStatusPopup(MaterialOrderData.sapNumber);
                                      }
                                    }}
                                  />
                                </Box>
                              }
                            /> :
                            <FormControlLabel
                              disabled
                              control={
                                <Box p={0.8}>
                                  <ControlCameraIcon
                                    size="small"
                                    color="primary"
                                    style={{ color: '#93b9c7' }}
                                  />
                                </Box>
                              }
                            />}
                        </Grid>
                        {IsHitachiCountry ?
                          <Grid item xs={1} sm={1} lg={1}>
                            <FormControlLabel
                              control={
                                <Box p={0.8}>
                                  <CardMembershipIcon
                                    size="small"
                                    color="primary"
                                    style={{ color: '#3399FF' }}
                                    onClick={() => {
                                      if (IsHitachiCountry) {
                                        CreditLimitNote(SessionUser.ServiceShopId);
                                      }
                                    }}
                                  />
                                </Box>
                              }
                            />
                          </Grid> : ''}

                        <Grid item xs={12} sm={12} lg={12}>
                          <ThemeProvider theme={materialTheme}>
                            <MuiPickersUtilsProvider
                              utils={DateFnsUtils}
                              locale={localeMap[locale]}
                            >
                              <KeyboardDatePicker
                                color="primary"
                                inputVariant="outlined"
                                id="orderDate"
                                disabled
                                size="small"
                                invalidDateMessage={t('hatali_tarih')}
                                format="dd.MM.yyyy"
                                fullWidth
                                autoComplete="off"
                                label={t('lblOrderDate')}
                                variant="outlined"
                                value={MaterialOrderData.orderDate}
                                onChange={e => SetDate(e)}
                                KeyboardButtonProps={{
                                  'aria-label': 'change date'
                                }}
                              />
                            </MuiPickersUtilsProvider>
                          </ThemeProvider>
                        </Grid>
                        <Grid item xs={6} sm={12} lg={12}>
                          <TextField
                            size="small"
                            disabled
                            id="ServiceShop"
                            autoComplete="no"
                            value={serviceData.serviceShopDsc}
                            fullWidth
                            label={t('lblServiceShop')}
                            variant="outlined"
                          />
                        </Grid>
                        <Grid item xs={9} sm={9} lg={9}>
                          <TextField
                            size="small"
                            id="consumer"
                            autoComplete="no"
                            value={serviceAddressData.Dsc ? serviceAddressData.Dsc : serviceAddressData.ShipTo}
                            fullWidth
                            label={t('lblShipTo')}
                            variant="outlined"
                            disabled
                          />
                        </Grid>
                        <Grid item xs={3} sm={3} lg={3}>
                          <Button
                            variant="contained"
                            style={{
                              backgroundColor: '#1E5128',
                              color: 'white'
                            }}
                            endIcon={<SearchIcon />}
                            fullWidth
                            onClick={() => setServiceShopSearchPopUp(true)}
                          >
                            {t('search')}
                          </Button>
                        </Grid>
                        <Grid item xs={6} sm={6} lg={6}>
                          <TextField
                            size="small"
                            id="consumerName"
                            disabled
                            autoComplete="no"
                            value={serviceAddressData.Name}
                            fullWidth
                            label={t('lblConsumerName')}
                            variant="outlined"
                          />
                        </Grid>
                        <Grid item xs={6} sm={6} lg={6}>
                          <TextField
                            size="small"
                            id="consumerPhone"
                            disabled
                            autoComplete="no"
                            value={serviceData.serviceShopPhone}
                            fullWidth
                            label={t('lblConsumerPhone')}
                            variant="outlined"
                          />
                        </Grid>

                        <Grid item xs={12} sm={12} lg={12}>
                          <TextField
                            size="small"
                            id="status"
                            disabled
                            autoComplete="no"
                            value={MaterialOrderData.status}
                            onChange={event =>
                              setMaterialOrderData({
                                ...MaterialOrderData,
                                status: event.target.value
                              })}
                            fullWidth
                            label={t('lblStatus')}
                            variant="outlined"
                          />
                        </Grid>

                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
                {/* jobNumber p-2*/}
                <Grid item xs={12} sm={6} lg={6}>
                  <Card>
                    <CardContent className={classes.cardscontent}>
                      <Grid container spacing={1}>
                        <Grid item xs={12} sm={6} lg={6}>
                          <TextField
                            size="small"
                            id="jobNumber"
                            autoComplete="no"
                            type="number"
                            value={MaterialOrderData.jobNumber}
                            onKeyDown={blockInvalidChar}
                            onChange={event =>
                              setMaterialOrderData({
                                ...MaterialOrderData,
                                jobNumber: event.target.value
                              })}
                            fullWidth
                            label={t('lblWorkOrderId')}
                            variant="outlined"
                            onInput={(e) => {
                              e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 10)
                            }}
                            min={0}
                            required={workOrderIdControl}
                          />
                        </Grid>
                        <Grid item xs={6} sm={6} lg={6}>
                          <TextField
                            size="small"
                            id="poNumber"
                            autoComplete="no"
                            type="string"
                            value={MaterialOrderData.poNumber}
                            onChange={event =>
                              setMaterialOrderData({
                                ...MaterialOrderData,
                                poNumber: event.target.value.slice(0, 20)
                              })}
                            fullWidth
                            label={t('PO Number')}
                            variant="outlined"
                          />
                        </Grid>
                        {/* {SessionUser.TenantId == 87 || SessionUser.TenantId == 16 ?
                            <Grid item xs={6} sm={2} lg={2}>
                            <FormControl component="fieldset">
                              <RadioGroup aria-label="foc" name="foc" value={selectedValueFOC} onClick={handleChangeFOC}>
                                <FormControlLabel value={1} control={<Radio style={{color:'#9DC08B'}}/>} label="FOC"/>
                              </RadioGroup>
                            </FormControl>
                            </Grid> : '' } */}

                        <Grid item xs={12} sm={12} lg={12}>
                          <TextField
                            size="small"
                            id="description"
                            multiline
                            rows={10}
                            autoComplete="no"
                            value={MaterialOrderData.description}
                            onChange={event =>
                              setMaterialOrderData({
                                ...MaterialOrderData,
                                description: event.target.value
                              })}
                            fullWidth
                            label={t('lblDescription')}
                            variant="outlined"
                          />
                        </Grid>
                        {IsHitachiCountry ?
                          <Grid item xs={12} sm={12} lg={12}>
                            <FormControl fullWidth variant="outlined" className={classes.formControl}>
                              <TextField
                                size="small"
                                fullWidth
                                select
                                label={t('StorageLocation')}
                                onChange={handleChangeStorageLocation}
                                value={storageLocation}
                                variant="outlined"
                                disabled={isDisabled}
                              >
                                {StorageLocationData.map(p => {
                                  return (
                                    <MenuItem key={p.Id} value={p.Id}>
                                      {p.Dsc}
                                    </MenuItem>
                                  );
                                })}
                              </TextField>
                            </FormControl>
                          </Grid>
                          : ''}
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
                {/* alert p-4*/}
                <Grid item xs={12} sm={12} lg={12}>
                  <Alert
                    message={t('priceMessage')}
                    variant={'warning'}
                  />
                </Grid>
                {/* material p-5*/}
                <Grid item xs={12} sm={12} lg={12}>
                  <Card>
                    <BottomNavigation>
                      <ExcelExport JsonData={exportMaterialData(SparepartData)} ButtonType={1} />
                      <BottomNavigationAction
                        onClick={() => setSelectedMaterialPopup(true)}
                        showLabel
                        label={t('Add Material')}
                        icon={<AddBoxIcon style={{ color: '#394867' }} fontSize="large" />}
                      />
                      <BottomNavigationAction
                        onClick={() => setSelectedProductMaterialPopup(true)}
                        showLabel
                        label={t('Add Material From Product')}
                        icon={<AddBoxIcon style={{ color: '#394867' }} fontSize="large" />}
                      />
                    </BottomNavigation>
                    <Divider />
                    <TableContainer style={{ marginTop: '15px' }} component={Paper}>
                      <Table
                        className={classes.table}
                        size="small"
                        aria-label="a dense table"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell />
                            <TableCell />
                            <TableCell align="left">{t('lblMaterial')}</TableCell>
                            {SessionUser.TenantId === 16 ?
                              <TableCell align="left">{t('lblItemNote')}</TableCell>
                              : <TableCell align="left" />}
                            <TableCell align="right">{t('lblPrice')}</TableCell>
                            <TableCell align="right">
                              {t('lblDiscount')}
                            </TableCell>
                            <TableCell align="right">
                              {t('lblDiscountedPrice')}
                            </TableCell>
                            <TableCell align="right">{t('lblVatRate')}</TableCell>
                            <TableCell align="right">{t('lblQuantity')}</TableCell>
                            <TableCell align="center">{t('lblTotal')}</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {SparepartData.map(row => (
                            <TableRow key={row.MaterialId}>
                              <TableCell align="center">
                                <FormControlLabel
                                  control={
                                    <Box p={0.8}>
                                      <DeleteIcon
                                        size="large"
                                        style={{ color: '#A02334' }}
                                        onClick={() => deleteFromMaterialTable(row)}
                                      />
                                    </Box>
                                  }
                                />
                              </TableCell>
                              <TableCell align="center">
                                <FormControlLabel
                                  control={
                                    <Box p={0.8}>
                                      <LocalGroceryStoreIcon
                                        size="large"
                                        style={{ color: '#708871' }}
                                        onClick={() => StokControlPopup(row)}
                                      />
                                    </Box>
                                  }

                                />
                              </TableCell>
                              <TableCell align="left" component="th" scope="row">
                                {row.MaterialCode + ' - ' + row.MaterialDesc}
                              </TableCell>
                              {SessionUser.TenantId === 16 ?
                                <TableCell align="left">{orderData?.MaterialOrderDetails?.find(x => x.MaterialId === row.MaterialId).ItemNote}</TableCell>
                                : <TableCell align="left" />
                              }
                              <TableCell align="right">
                                {SessionUser.ServiceShopPriceVisible ? moneyFormat(
                                  row.Price,
                                  SessionUser.TenantCode,
                                  SessionUser.CurrencyUnit
                                ) : 0}
                                {`${SessionUser.CurrencyUnit}`}
                              </TableCell>
                              <TableCell align="center">{row.DiscountRatio}</TableCell>
                              <TableCell align="right">
                                {SessionUser.ServiceShopPriceVisible ? moneyFormat(
                                  row.DiscountedPrice,
                                  SessionUser.TenantCode,
                                  SessionUser.CurrencyUnit
                                ) : 0}
                                {`${SessionUser.CurrencyUnit
                                  }`}
                              </TableCell>
                              <TableCell align="center">
                                {(((row.Vat ?? row.VatRate ?? 0) * 100).toFixed(2))}
                              </TableCell>
                              <TableCell align="right">
                                <Input style={{ width: '45px', textAlign: 'center', backgroundColor: QuantityState.backgroundColor }} type='number' textAlign='center' value={row.Quantity} onChange={(e) => handleQuantityChange(e, row)} />
                              </TableCell>
                              <TableCell align="right" className={classes.totalPriceCell}>
                                <Box className={classes.priceBox}>
                                  {SessionUser.ServiceShopPriceVisible
                                    ? `${moneyFormat(row.DiscountedPrice ? row.DiscountedPrice * row.Quantity : row.Price * row.Quantity, SessionUser.TenantCode, SessionUser.CurrencyUnit)}`
                                    : 0}
                                  <span className={classes.currencyUnit}>
                                    {SessionUser.CurrencyUnit}
                                  </span>
                                </Box>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <Box style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end' }}>
                      <Box className={classes.vatBox}>
                        <PinIcon className={classes.pinIcon} />
                        <Typography variant="body1" className={classes.price} style={{ display: 'flex', justifyContent: 'space-between' }}>
                          <span>{t('lblTotalPrice')}:</span>
                          <span>{totalSum} {SessionUser.CurrencyUnit}</span>
                        </Typography>
                        <Typography variant="body1" className={classes.price} style={{ display: 'flex', justifyContent: 'space-between' }}>
                          <span>{t('lblVat')} (%{vatRate}):</span>
                          <span>{vat} {SessionUser.CurrencyUnit}</span>
                        </Typography>
                        <Typography variant="body1" className={classes.price} style={{ display: 'flex', justifyContent: 'space-between' }}>
                          <span>{t('lblTotalWithVat')}:</span>
                          <span>{priceWithVAT} {SessionUser.CurrencyUnit}</span>
                        </Typography>
                      </Box>
                    </Box>
                  </Card>
                </Grid>
              </Grid>
              <Grid container item xs={12} sm={4} lg={4} spacing={1}>
                {/* tab p-3*/}
                <Grid item xs={12} sm={12} lg={12}>
                  <Card>
                    <CardContent className={classes.cardscontent}>
                      <AppBar position="static">
                        <Tabs value={tabsValue} onChange={handleChangetabs} aria-label="simple tabs example">
                          <Tab label={t('lblShipTo')} icon={<LocalShippingOutlinedIcon />} {...a11yProps(0)} />
                          <Tab label={t('lblBillTo')} icon={<DescriptionOutlinedIcon />} {...a11yProps(1)} />
                        </Tabs>
                      </AppBar>
                      <TabPanel value={tabsValue} index={0}>
                        <ConsumerAddress
                          consumerAddressData={serviceAddressData}
                          setStreetData={setStreetData}
                          setApartmentData={setApartmentData}
                          setAddressData={setAddressData}
                          setStateData={setStateData}
                          setAddressItemData={setAddressItemData}
                          setCityData={setCityData}
                          setCountryData={setCountryData}
                          setDistrictData={setDistrictData}
                          setDoorNrData={setDoorNrData}
                          setNeighborhoodData={setNeighborhoodData}
                          setPostCodeData={setPostCodeData}
                          setRegionData={setRegionData}
                          setAddressTypeIdData={setAddressTypeIdData}
                        />
                      </TabPanel>
                      <TabPanel value={tabsValue} index={1}>
                        <ServiceShopBillTo
                          serviceAddressData={serviceAddressData}
                        />
                      </TabPanel>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        <Dialog
          open={ConsumerSearchPopUp}
          onClose={() => setConsumerSearchPopUp(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth
          maxWidth="lg"
        >
          <DialogTitle id="alert-dialog-title">
            {t('lblConsumerSearch')}
            <Divider />
          </DialogTitle>
          <DialogContent>
            <CardContent>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12} lg={12}>
                  <ConsumerSearch
                    handleClick={handleClick}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              style={{ backgroundColor: '#B31312', color: 'white' }}
              size="small"
              component="span"
              onClick={() => setConsumerSearchPopUp(false)}
            >
              {t('lblClose')}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={ServiceShopSearchPopUp}
          onClose={() => setServiceShopSearchPopUp(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth
          maxWidth="lg"
        >
          <DialogTitle id="alert-dialog-title">
            {t('lblServiceShopSearch')}
            <Divider />
          </DialogTitle>
          <DialogContent>
            <CardContent>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12} lg={12}>
                  <ServiceShopSearch
                    handleClickService={handleClickService}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              style={{ backgroundColor: '#B31312', color: 'white' }}
              size="small"
              component="span"
              onClick={() => setServiceShopSearchPopUp(false)}
            >
              {t('lblClose')}
            </Button>
          </DialogActions>
        </Dialog>
        <EditMaterial
          open={openEdit}
          value={1}
          min={1}
          max={999}
          onClose={handleCloseEdit}
          materialId={materialId}
          materialCode={materialCode}
          materialDesc={materialDesc}
          sparePartMessage={sparePartMessage}
          setQuantityNum={setQuantityNum}
        />
        {/* Add Material From Product BOM */}
        <Dialog
          open={SelectedProductMaterialPopup}
          fullWidth
          maxWidth="lg"
          onClose={() => setSelectedProductMaterialPopup(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description" >
          <Grid container >
            <Grid xs={1} sm={1} lg={1}></Grid>
            <Grid item xs={10} sm={10} lg={10}>
              <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center' }}>
                {t('Add Material From Product BOM')}
              </DialogTitle>
            </Grid>
            <Grid xs={1} sm={1} lg={1}>
              <DialogActions>
                <IconButton
                  color="primary"
                  onClick={() => setSelectedProductMaterialPopup(false)}
                  aria-label="upload picture"
                  component="span">
                  <CloseIcon />
                </IconButton>
              </DialogActions>
            </Grid>
          </Grid>
          <Container maxWidth="xl" spacing={1}>
            <Divider />
            <Card>
              <CardContent>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={12} lg={12}>
                    <UrunSearch
                      setModel={(param) => setModel(param)}
                      value={
                        {
                          KUL_MODEL_KODU: UrunData.ModelCode,
                          ACIKLAMA: UrunData.Model
                        } || ''
                      }
                      searchParam={search}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} lg={12}>
                    <SerialNumberParse
                      SKU={UrunData.ModelCode}
                      MODEL={UrunData.Model}
                      BRANDCODE={UrunData.BrandCode}
                      PRODUCTID={UrunData.ProductId}
                      GetHistoricalBom={GetHistoricalBom}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} lg={12}>
                    <ProductMaterialSearch
                      setProductMaterial={setProductMaterial}
                      materialIsVisible={(UrunData.Model && UrunData.ModelCode && UrunData.ProductId >= 1000000) ? true : false}
                    />
                  </Grid>
                </Grid>
              </CardContent>
              <Divider />
              <CardContent>
                <Grid container spacing={1}>
                  <Grid item xs={4} sm={4} lg={4}>
                    <SearchBar
                      inputSizeSmall
                      value={searched}
                      onChange={searchVal => requestSearch(searchVal)}
                      onCancelSearch={() => cancelSearch()}
                      style={{ margin: '0 auto', maxWidth: 800, maxHeight: 37 }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} lg={12}>
                    <TableContainer component={Paper}>
                      <Table
                        stickyHeader
                        className={classes.table}
                        size="small"
                        aria-label="sticky table"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell />
                            <TableCell />
                            <TableCell />
                            <TableCell align="left">
                              {t('lblMaterialCode')}
                            </TableCell>
                            <TableCell align="left">
                              {t('lblDescription')}
                            </TableCell>
                            <TableCell align="left">
                              {t('lblRef')}
                            </TableCell>
                            <TableCell align="right">{t('lblPrice')}</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {(rowsPerPage > 0
                            ? MaterialListData.slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            )
                            : MaterialListData
                          ).map(row => (
                            <TableRow
                              key={row.MaterialId}
                              style={
                                SparepartData.some(item => item.MaterialId === row.MaterialId)
                                  ? { backgroundColor: '#DEF5E5' }
                                  : {}
                              }
                            >
                              <TableCell className={classes.tableCell}>
                                <ImageSearchIcon
                                  onClick={() => malzemeGosterMaterial(row.MaterialCode)}
                                  color="primary"
                                />
                              </TableCell>
                              <TableCell className={classes.tableCell}>
                                <TrackChangesIcon
                                  onClick={() =>
                                    GetSiriusActiveEquivalentMaterialCodes(row.MaterialCode)

                                  }
                                  color="primary"
                                />
                              </TableCell>
                              <TableCell align="center" className={classes.tableCell}>
                                <AddBoxIcon
                                  color="primary"
                                  onClick={() => addToMaterialTable(row)}
                                />
                              </TableCell>
                              <TableCell align="left" className={classes.tableCell}>
                                {row.MaterialCode}
                              </TableCell>
                              <TableCell align="left" className={classes.tableCell}>
                                {row.MaterialDesc}

                              </TableCell>
                              <TableCell align="left">
                                {row.Ref}
                              </TableCell>
                              <TableCell align="right" className={classes.tableCell}>
                                {`${SessionUser.ServiceShopPriceVisible
                                  ? (row.Price || 0).toFixed(2)
                                  : '0'} ${SessionUser.CurrencyUnit}`}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                      <TablePagination
                        rowsPerPageOptions={[5, 10]}
                        component="div"
                        count={MaterialListData.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onChangePage={handleChangePage}
                        onChangeRowsPerPage={handleChangeRowsPerPage}
                      />
                    </TableContainer>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Container>
          <DialogActions />
        </Dialog>
        {/* Material Add */}
        <Dialog
          open={SelectedMaterialPopup}
          fullWidth
          maxWidth="lg"
          onClose={() => setSelectedMaterialPopup(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <Grid container >
            <Grid xs={1} sm={1} lg={1}></Grid>
            <Grid item xs={10} sm={10} lg={10}>
              <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center' }}>
                {t('lblMaterialChoose')}
              </DialogTitle>
            </Grid>
            <Grid xs={1} sm={1} lg={1}>
              <DialogActions>
                <IconButton
                  color="primary"
                  onClick={() => setSelectedMaterialPopup(false)}
                  aria-label="upload picture"
                  component="span">
                  <CloseIcon />
                </IconButton>
              </DialogActions>
            </Grid>
          </Grid>
          <Container maxWidth="xl" spacing={1}>
            <Divider />
            <Card>
              <CardContent>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={12} lg={12}>
                    <OutlinedInput
                      id="outlined-adornment"
                      fullWidth
                      placeholder={t('Please Enter Material Code Or Name Then Click The Button')}
                      value={inputText}
                      onChange={handleChange}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton type="button" sx={{ p: '10px' }} aria-label="search"
                            onClick={() => setSearchMaterial()}
                          >
                            <SearchIcon />
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </Grid>
                </Grid>
              </CardContent>
              <Divider />
              <CardContent>
                <Grid container spacing={1}>
                  <Grid item xs={4} sm={4} lg={4}>
                    <SearchBar
                      value={searched}
                      onChange={searchVal => requestSearch2(searchVal)}
                      onCancelSearch={() => cancelSearch()}
                      style={{ margin: '0 auto', maxWidth: 800, maxHeight: 37 }}
                    />
                  </Grid>
                  <Grid item xs={4} sm={4} lg={4}>
                    <input
                      id="FileInput"
                      type='file'
                      onChange={importExcel}
                      hidden
                      accept=".xlsx, .xls, .xml"
                    >
                    </input>
                    <label htmlFor="FileInput">
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        fullWidth
                        component="span"
                      >
                        {t('lblChooseFile')}
                      </Button>
                    </label>
                  </Grid>
                  <Grid item xs={4} sm={4} lg={4}>
                    <ExcelExport JsonData={exportExcelExample} ButtonType={5} ButtonText={'EXCEL EXAMPLE'} />
                  </Grid>
                  <Grid item xs={12} sm={12} lg={12}>
                    <TableContainer component={Paper}>
                      <Table
                        stickyHeader
                        className={classes.table}
                        size="small"
                        aria-label="sticky table"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell />
                            <TableCell />
                            <TableCell />
                            <TableCell align="left">
                              {t('lblMaterialCode')}
                            </TableCell>
                            <TableCell align="left">
                              {t('lblDescription')}
                            </TableCell>
                            <TableCell align="right">{t('lblPrice')}</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {(rowsPerPage > 0
                            ? MaterialListData2.slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            )
                            : MaterialListData2
                          ).map(row => (
                            <TableRow
                              key={row.MaterialId}
                              style={
                                SparepartData.some(item => item.MaterialId === row.MaterialId)
                                  ? { backgroundColor: '#DEF5E5' }
                                  : {}
                              }
                            >
                              <TableCell align="center" className={classes.tableCellMaterial}>
                                <FormControlLabel
                                  control={
                                    <ImageSearchIcon
                                      onClick={() => malzemeGosterMaterial(row.MaterialCode)}
                                      color="primary"
                                    />
                                  }
                                />
                              </TableCell>
                              <TableCell className={classes.tableCell}>
                                <TrackChangesIcon
                                  onClick={() =>
                                    GetSiriusActiveEquivalentMaterialCodes(row.MaterialCode)
                                  }
                                  color="primary"
                                />
                              </TableCell>
                              <TableCell align="center">
                                <FormControlLabel
                                  control={
                                    <AddBoxIcon
                                      color="primary"
                                      onClick={() => addToMaterialTable(row)}
                                    />
                                  }
                                />
                              </TableCell>
                              <TableCell align="left">
                                {row.MaterialCode}
                              </TableCell>
                              <TableCell align="left">
                                {row.MaterialDesc}
                                {row.ActiveEquivalent ? (
                                  <Chip color="secondary" size="small" label="M" />
                                ) : null}
                              </TableCell>
                              <TableCell align="right">
                                {`${SessionUser.ServiceShopPriceVisible
                                  ? (row.Price || 0).toFixed(2)
                                  : '0'} ${SessionUser.CurrencyUnit}`}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                      <TablePagination
                        rowsPerPageOptions={[5, 10]}
                        component="div"
                        count={MaterialListData2.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onChangePage={handleChangePage}
                        onChangeRowsPerPage={handleChangeRowsPerPage}
                      />
                    </TableContainer>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Container>
          <DialogActions />
        </Dialog>
        {/* EQUIVALENT MATERIALS */}
        <Dialog
          fullWidth
          open={muadilOpen}
          onClose={() => setMuadilOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {muadilTitle} {t('lblMalzemeninBulteni')}
          </DialogTitle>
          <DialogContent>
            <TableContainer>
              <Table size="small" aria-label="material table">
                <TableBody className={classes.table}>
                  {muadilParam.length === 0
                    ? '...'
                    : muadilParam.split(',').map((m, index) => {
                      return getMaterialRow(equivalentData, index);
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => setMuadilOpen(false)}
              className={classes.button}
              endIcon={<CloseIcon>Close</CloseIcon>}
            >
              {t('lblOkey')}
            </Button>
          </DialogActions>
        </Dialog>
        {/* Missing Materials */}
        <Dialog
          open={MissingMaterialsPopUp}
          fullWidth
          maxWidth="lg"
          onClose={() => missingMaterialsPopUp(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <Grid container >
            <Grid xs={1} sm={1} lg={1}></Grid>
            <Grid item xs={10} sm={10} lg={10}>
              <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center' }}>
                {t('Missing Materials')}
              </DialogTitle>
            </Grid>
            <Grid xs={1} sm={1} lg={1}>
              <DialogActions>
                <IconButton
                  color="primary"
                  onClick={() => missingMaterialsPopUp(false)}
                  aria-label="upload picture"
                  component="span">
                  <CloseIcon />
                </IconButton>
              </DialogActions>
            </Grid>
          </Grid>
          <Container maxWidth="xl" spacing={1}>
            <label style={{ color: 'red' }}>The following material codes were not found or defined in your region</label>
            <Divider />
            <Paper style={{ maxHeight: 300, overflow: 'auto' }}>
              <List>
                {MissingMaterials.map((item) =>
                  <ListItem>
                    <ListItemText >{item.MaterialCode}</ListItemText >
                  </ListItem>
                )}
              </List>
            </Paper>
          </Container>
          <DialogActions />
        </Dialog>
        <Dialog
          open={ImagePopup}
          fullWidth
          maxWidth="sm"
          onClose={() => setImagePopup(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <img width="auto" height="auto" src={ImageUrl} style={{ border: 'none' }} onclick={() => setImagePopup(false)}></img>
        </Dialog>

        <Dialog
          open={stokOpen}
          onClose={() => setStokOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth
        >
          <DialogTitle id="alert-dialog-title">
            {t('lblMaterialStockSituation')}
            <Divider />
          </DialogTitle>
          <DialogContent>
            <List component="div" dense>
              {loading2 ? (
                <CircularProgress status="loading" style={{ marginLeft: '50%' }} />
              ) : (
                <>
                  {/* stokDataOwnEngineer */}
                  {SessionUser.TenantId !== 49 && (serviceShopTypeId === 1 || (SessionUser.TenantId === 46 && serviceShopTypeId === 2)) ? (
                    <>
                      {stokDataOwnEngineer.length > 0 ? (
                        <>
                          <Typography>{t('VanStock')}</Typography>
                          {stokDataOwnEngineer.map((s, index) => (
                            <React.Fragment key={index}>
                              <ListItem fullWidth alignItems="flex-start">
                                <ListItemAvatar>{getStokColor(s)}</ListItemAvatar>
                                <ListItemText
                                  primary={
                                    <Typography variant="body1" className={classes.nestedRight}>
                                      <b>{s.MaterialCode}</b>
                                    </Typography>
                                  }
                                  secondary={
                                    <>
                                      <Typography
                                        component="span"
                                        variant="h6"
                                        className={classes.inline}
                                        color="textPrimary"
                                      >
                                        {t('OwnEngineer')} : {s.StorageLocation}
                                        <br />
                                        {t('lblAdet')} : {s.Quantity}
                                        <br />
                                        {t('Tarih')} : {s.Date != null ? moment(s.Date).format('DD/MM/YYYY') : '-'}
                                        <br />
                                        {SessionUser.TenantId === 87 || SessionUser.TenantId === 16 ? (
                                          <div>
                                            {t('ETA')} : {s.ETA === new Date(0).getTime() || s.Quantity === 0 ? '-' : moment(s.ETA).format('DD/MM/YYYY')}
                                          </div>
                                        ) : null}
                                      </Typography>
                                    </>
                                  }
                                />
                              </ListItem>
                              <Divider variant="inset" component="li" />
                            </React.Fragment>
                          ))}
                        </>
                      ) : (
                        <Typography>{stockMsg}</Typography>
                      )}
                    </>
                  ) : null}
                  <Divider variant="inset" component="li" />
                  {/* stokData */}
                  {(stockDataLoading || stokData.length > 0) && IsAllOwnEngineer == false ? <Typography>Stock Data</Typography> : ''}
                  {stockDataLoading && IsAllOwnEngineer == false && (
                    <ListItem role="status" aria-label="Stock Data">
                      <CircularProgress size={24} aria-label="Stock Data" />
                    </ListItem>
                  )}
                  {!stockDataLoading && stokData.length > 0 && IsAllOwnEngineer == false ? stokData.map((s, index) => (
                    <React.Fragment key={index}>
                      <ListItem fullWidth alignItems="flex-start">
                        <ListItemAvatar>{getStokColor(s)}</ListItemAvatar>
                        <ListItemText
                          primary={
                            <Typography
                              variant="body1"
                              className={classes.nestedRight}
                            >
                              <b>{s.MaterialCode}</b>
                            </Typography>
                          }
                          secondary={
                            <React.Fragment>
                              <Typography
                                component="span"
                                variant="h6"
                                className={classes.inline}
                                color="textPrimary"
                              >
                                {t(s.StockSource === 'Customer' ? 'VanStock' : 'StorageDesc')} : {s.StorageLocation}
                                <br />
                                {t('lblAdet')} : {s.Quantity}
                                <br />
                                {t('Tarih')} : {s.Date != null ? moment(s.Date).format('DD/MM/YYYY') : "-"}
                                <br />
                                {SessionUser.TenantId === 87 || SessionUser.TenantId === 16 && (
                                  <div>
                                    {t('ETA')} : {s.ETA === new Date(0).getTime() || s.Quantity == 0 ? "-" : moment(s.ETA).format('DD/MM/YYYY')}
                                  </div>
                                )}
                              </Typography>
                            </React.Fragment>
                          }
                        />
                      </ListItem>
                      <Divider variant="inset" component="li" />
                    </React.Fragment>
                  )) : ''}
                  {virtualStockEnabledLoaded && virtualStockEnabled && (
                    <VirtualStockPanel
                      loading={virtualLoading}
                      total={virtualTotal}
                      invoices={virtualInvoices}
                      expanded={showVirtualDetail}
                      onToggle={toggleVirtualDetail}
                      t={t}
                    />
                  )}
                </>
              )}
            </List>
          </DialogContent>
          <DialogActions>
            {SessionUser.TenantId !== 49 && (serviceShopTypeId === 1 || (SessionUser.TenantId === 46 && serviceShopTypeId === 2)) ? (
              <div>
                {backButtonVisible ? (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleBackButtonClick}
                  >
                    {t('lblBack')}
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => StockSearch(false)}
                  >
                    {t('lblFieldStock')}
                  </Button>
                )}
              </div>
            ) : null}
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setStokOpen(false);
                setBackButtonVisible(false)
              }}
            >
              {t('lblOk')}
            </Button>
          </DialogActions>
        </Dialog>
        <ErpStatusDialog
          open={ErpStatusOpen}
          onClose={() => setErpStatusOpen(false)}
          loading={loading}
          data={ErpStatusData}
          TenantId={SessionUser.TenantId}
          IsHitachiCountry={IsHitachiCountry}
          materialList={
            orderData?.MaterialOrderDetails && orderData.MaterialOrderDetails.length > 0
              ? orderData.MaterialOrderDetails
              : SparepartData
          }
        />
        {/* --- KREDİ LİMİTİ DIALOG BAŞLANGIÇ --- */}
        <Dialog
          open={creditLimitOpen}
          onClose={() => setCreditLimitOpen(false)}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>
            {t('lblCreditLimitInformation')}
          </DialogTitle>
          <DialogContent dividers>
            {loading2 ? (
              <Box display="flex" justifyContent="center" p={3}>
                <CircularProgress />
              </Box>
            ) : creditLimitData ? (
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="subtitle2" color="textSecondary">
                    {t('lblErpCode')}
                  </Typography>
                  <Typography variant="body1">
                    {creditLimitData.CustomerCode || '-'}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle2" color="textSecondary">
                    {t('lblCreditLimit')}
                  </Typography>
                  <Typography variant="h6" style={{ color: 'green' }}>
                    {creditLimitData.CreditLimit
                      ? `${parseFloat(creditLimitData.CreditLimit).toLocaleString('tr-TR', { minimumFractionDigits: 2 })}`
                      : '0.00'}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography variant="subtitle2" color="textSecondary">
                    {t('lblCreditExposure')}
                  </Typography>
                  <Typography variant="h6" style={{ color: 'red' }}>
                    {creditLimitData.CreditExposure
                      ? `${parseFloat(creditLimitData.CreditExposure).toLocaleString('tr-TR', { minimumFractionDigits: 2 })}`
                      : '0.00'}
                  </Typography>
                </Grid>
              </Grid>
            ) : (
              <Typography color="error">
                {t('lblCreditLimitErrorResponse')}
              </Typography>
            )}
          </DialogContent>
        </Dialog>
        {/* --- CreditLimit --- */}
        <PricePreviewDialog
          open={openPricePreview}
          onClose={() => setopenPricePreview(false)}
          data={pricePreviewData}
          isApiSuccess={pricePreviewError.isApiSuccess}
          hasBusinessError={pricePreviewError.hasBusinessError}
          errorMessage={pricePreviewError.errorMessage}
          tenantId={SessionUser?.TenantId}
        />
        <RomaniaStorageLocationDialog
          open={storageLocationDialogOpen}
          onClose={() => setStorageLocationDialogOpen(false)}
          selectedCode={sapStorageLocationCode}
          onSelect={setSapStorageLocationCode}
        />
      </Container>
    </Page >
  );
};


export default ForPartner;
